import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import bank from './bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import { getBrand } from '../config/brand';
import Select from 'react-select';
import dayjs from 'dayjs';
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import { Copy, Info, Ban } from 'lucide-react';

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import { changeNum, convertDateFormat } from './common/function';
import useWindowSize from './hook/useWindowSize'
import { useAccountHolderVerify, verifyBtnStyle, verifiedBadgeStyle } from './hook/useAccountHolderVerify';
import { MerchantAuditView } from './auditLog';

const MANUAL_SAME_CARD_DAILY_LIMIT_OPTIONS = Array.from({ length: 10 }, (_, index) => index + 1);

const normalizeManualSameCardDailyLimit = (value) => {
    const numericValue = Number(value);
    return MANUAL_SAME_CARD_DAILY_LIMIT_OPTIONS.includes(numericValue) ? numericValue : 1;
};

const buildManualSameCardLimitPayload = (formData) => {
    const enabled = formData?.동일카드일일수기결제제한 === "Y";
    return {
        manual_same_card_limit_yn: enabled ? "Y" : "N",
        manual_same_card_daily_limit: enabled
            ? normalizeManualSameCardDailyLimit(formData?.동일카드일일수기결제허용횟수)
            : null,
    };
};

const canManageMerchantTerminalFee = (myData) => myData?.role === "SUPER";
const isTerminalFeeSettingBrand = () => ["fast", "baekma"].includes(getBrand().key);
const isFastBrand = () => getBrand().key === "fast";
const DEFAULT_TERMINAL_FEE_APPLY_TYPE = "NEXT_MONTH";
const CURRENT_TERMINAL_FEE_APPLY_TYPE = "CURRENT_MONTH";

const TERMINAL_FEE_CHARGE_ACTION_LABEL = {
    CREATED: "이번달 부과건 생성",
    ALREADY_EXISTS: "이번달 부과건 이미 존재",
    NO_ACTIVE_TERMINAL: "활성 단말기 없음",
    FLAG_ONLY: "부과 설정만 저장",
};

const TERMINAL_FEE_DEDUCTION_ACTION_LABEL = {
    DEDUCTED: "즉시 차감 완료",
    NO_ELIGIBLE_PAYOUT: "차감 가능 정산건 없음",
    WALLET_DEFERRED: "지갑 차감은 배치 대기",
    ALREADY_DEDUCTED_FROM_PAYOUT: "이미 정산 차감됨",
    NO_AVAILABLE_PAYOUT_AMOUNT: "차감 가능 금액 없음",
    NO_REMAINING_AMOUNT: "잔액 없음",
    NOT_ATTEMPTED: "즉시 차감 미시도",
};

const isTerminalFeeEnabledFromOff = (formData, originalFormData) => (
    isFastBrand()
    && formData?.단말기비부과 === "Y"
    && originalFormData?.단말기비부과 !== "Y"
);

const getTerminalFeeApplyPolicy = (formData, originalFormData) => {
    if (formData.단말기비부과 !== "Y") return "NONE";
    return isTerminalFeeEnabledFromOff(formData, originalFormData)
        ? formData.단말기비부과시점
        : DEFAULT_TERMINAL_FEE_APPLY_TYPE;
};

const getTerminalFeePolicyGuideLines = (formData) => {
    const isWallet = formData?.바우처사용 === "Y";
    if (formData?.단말기비부과 !== "Y") {
        return ["미부과로 저장하면 부과 대상에서 제외됩니다.", "이미 생성된 기존 부과건은 자동 취소되지 않습니다."];
    }

    if (formData?.단말기비부과시점 === CURRENT_TERMINAL_FEE_APPLY_TYPE) {
        return [
            "저장 즉시 부과 대상으로 전환하고 이번달 부과건 생성을 요청합니다.",
            "이미 이번달 부과건이 있으면 중복 생성하지 않습니다.",
            isWallet
                ? "지갑 정산 가맹점은 즉시 차감하지 않고 배치 차감 대기 상태가 됩니다."
                : "익일이체 정산건이 오늘자 이체 전이면 즉시 차감을 시도합니다.",
            "활성 단말기가 없으면 부과건이 생성되지 않을 수 있습니다.",
        ];
    }

    return [
        "부과 대상으로만 전환하고 이번달 부과건은 생성하지 않습니다.",
        "다음 부과월부터 월별 단말기비 부과 대상이 됩니다.",
        isWallet
            ? "지갑 정산은 해당 부과월 배치 차감 기준으로 처리됩니다."
            : "익일이체 정산은 해당 부과월 정산 차감 기준으로 처리됩니다.",
    ];
};

const buildTerminalFeeExemptionMessage = (data) => {
    const chargeAction = data?.charge?.action;
    const deductionAction = data?.deduction?.action;
    const parts = [];
    if (chargeAction) parts.push(TERMINAL_FEE_CHARGE_ACTION_LABEL[chargeAction] || chargeAction);
    if (deductionAction) parts.push(TERMINAL_FEE_DEDUCTION_ACTION_LABEL[deductionAction] || deductionAction);
    return parts.length > 0 ? "단말기비 설정: " + parts.join(" / ") : "단말기비 설정이 저장되었습니다.";
};

const saveFastTerminalFeeExemption = async (mid, formData, originalFormData) => {
    if (!isFastBrand()) return "";
    const response = await axios.post(
        process.env.REACT_APP_API + "/api/merchant-terminal-fee/exemption",
        {
            mid,
            apply_policy: getTerminalFeeApplyPolicy(formData, originalFormData),
        },
        { withCredentials: true }
    );
    const tmp = response?.data;
    if (tmp?.code < 2000) {
        return buildTerminalFeeExemptionMessage(tmp?.data);
    }
    throw new Error(tmp?.msg || "단말기비 설정 저장에 실패했습니다.");
};

function TerminalFeePolicyGuide({ formData }) {
    const lines = getTerminalFeePolicyGuideLines(formData);
    return (
        <div style={{ marginTop: "3px", padding: "7px 8px", border: "1px solid #e5e7eb", borderRadius: "4px", background: "#f8fafc", color: "#475569", fontSize: "11px", lineHeight: "1.45" }}>
            <div style={{ fontWeight: "700", color: "#334155", marginBottom: "3px" }}>처리 안내</div>
            {lines.map((line) => (
                <div key={line}>- {line}</div>
            ))}
        </div>
    );
}

function RevealSensitiveButton({ enabled, loading, revealed, onClick }) {
    if (!enabled) return null;

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={loading || revealed}
            style={{
                padding: "4px 10px",
                fontSize: "12px",
                borderRadius: "4px",
                border: revealed ? "1px solid #10b981" : "1px solid #2563eb",
                backgroundColor: revealed ? "#ecfdf5" : loading ? "#e5e7eb" : "#2563eb",
                color: revealed ? "#047857" : loading ? "#94a3b8" : "#ffffff",
                cursor: loading || revealed ? "default" : "pointer",
                fontWeight: "600",
                whiteSpace: "nowrap",
            }}
        >
            {revealed ? "원문 조회됨" : loading ? "조회중" : "민감정보 원문 조회"}
        </button>
    );
}

function Submerchants() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })
    const brand = useSelector((state) => state.brand);

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [loading, setLoading] = useState(true)
    const [loadingCnt, setLoadingCnt] = useState(false)

    const [createModal, setCreateModal] = useState(false)
    const [updateModal, setUpdataeModal] = useState(false);
    const [auditModal, setAuditModal] = useState(false);

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])
    const [clickData, setClickData] = useState(null) // 현재 선택된(수정 중인) 가맹점 데이터
    const [reload, setReload] = useState(false)
    const [level, setLevel] = useState(3)
    const [totalCount, setTotalCount] = useState(0)
    const [hasMore, setHasMore] = useState(true)

    // ▼ 탭 상태 (가맹점 수정 / 정산주기 / PG정보)
    const [activeTab, setActiveTab] = useState(MyData?.role == "SUPER" ? "가맹점 수정" : "가맹점 상세")
    const [listState, setListState] = useState(false)

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 검색구분 포맷
    const select4 = ["가맹점명", "가맹점아이디"]

    const [selectedValue3, setSelectedValue3] = useState("가맹점명");
    const [selectedText3, setSelectText3] = useState("")

    const handleSelectChange3 = (event) => {
        const value = event.target.value;
        setSelectedValue3(value);
    };

    const handleSelectTextChange3 = (event) => {
        const value = event.target.value;
        setSelectText3(value);
    };

    // 검색 버튼
    const submit = () => {
        setSelectText3(selectedText3.trim())
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("가맹점"))
        dispatch(changeHeaderTitle({
            mainTitle: "가맹점"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChange = (event) => {
        setPage(1)
        setMaxFirstPage(Number(event.target.value));
    };

    useEffect(() => {
        setPage(1)
        ListData(false)
    }, [reload])

    useEffect(() => {
        if (page > 1) {
            ListData(true)
        }
    }, [page])

    const ListData = async (isLoadMore = false) => {
        const currentPage = isLoadMore ? page : 1;
        await axios.get(process.env.REACT_APP_API + "/api/merchant", {
            withCredentials: true,
            params: {
                page: currentPage,
                limit: maxFirstPage,
                keyword: selectedText3.trim()
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                const newData = tmp?.data?.merchant ?? []
                const pagination = tmp?.data?.pagination ?? {}

                if (isLoadMore) {
                    setListData(prev => [...prev, ...newData])
                } else {
                    setListData(newData)
                }
                setTotalCount(pagination.total ?? 0)
                setHasMore(currentPage < (pagination.totalPages ?? 0))
                setLevel(tmp?.data?.agent?.level ?? 3)
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData =
        [
            // { "no": 1, "text": "ID", "width": "50px", "textAlign": "center" },
            { "no": 2, "text": "가맹점명", "width": "200px", "textAlign": "center" },
            { "no": 3, "text": "MID", "width": "120px", "textAlign": "center" },
            // { "no": 4, "text": "지사", "width": "110px", "textAlign": "center" },
            // { "no": 5, "text": "총판", "width": "110px", "textAlign": "center" },
            // { "no": 6, "text": "대리점", "width": "110px", "textAlign": "center" },
            // { "no": 7, "text": "단말기수수료", "width": "100px", "textAlign": "center" },
            // { "no": 8, "text": "카드수수료", "width": "100px", "textAlign": "center" },
            // { "no": 11, "text": "예금주명", "width": "120px", "textAlign": "center" },
            // { "no": 9, "text": "정산은행", "width": "100px", "textAlign": "center" },
            // { "no": 10, "text": "계좌번호", "width": "150px", "textAlign": "center" },
            // { "no": 12, "text": "사용여부", "width": "80px", "textAlign": "center" },
            // { "no": 13, "text": "등록일자", "width": "130px", "textAlign": "center" },
            { "no": 14, "text": "수정일자", "width": "110px", "textAlign": "center" },
            // // { "no": 15, "text": "작업자", "width": "70px", "textAlign": "center" },
            // { "no": 16, "text": "수정", "width": "70px", "textAlign": "center" }
        ]

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            setCombineList(listData)

            for (let i = 0; i < listData.length; i++) {
                let data = listData[i]

                let rowData = [
                    {
                        "no": 2,
                        "text": data.terminated_at ? (
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                <Ban size={14} color="#dc3545" strokeWidth={2.5} />
                                <span style={{ color: "#888", textDecoration: "line-through" }}>{data.co_nm ?? ""}</span>
                            </span>
                        ) : (data.co_nm ?? ""),
                        "width": "200px",
                        "textAlign": "left"
                    },
                    { "no": 3, "text": data.mid, "width": "120px", "textAlign": "left" },
                    { "no": 14, "text": convertDateFormat(data.mod_dt), "width": "110px", "textAlign": "center" },
                ]

                rowData.id = data.id
                tableBodyData.push(rowData);
            }
            setListState(e => !e)
            setCombineData(tableBodyData)
        }
    }, [listData])

    const handleRowClick = (row) => {
        const found = combineList.find((d) => d.id == row.id);
        if (found) {
            setClickData(found);
            setActiveTab(MyData?.role == "SUPER" ? "가맹점 수정" : "가맹점 상세");
            setCreateModal(false)
            setUpdataeModal(true)
        }
    }

    const [excelState, setExcelState] = useState(true)
    const [excelDownloadModal, setExcelDownloadModal] = useState(false)
    const [excelDownloadType, setExcelDownloadType] = useState("masked")
    const [excelDownloadReason, setExcelDownloadReason] = useState("")
    const canSelectMerchantExcelFormat = getBrand().key === "baekma" && MyData?.admin_id === "test";

    const excelBtn = async ({ reveal = false, reason = "" } = {}) => {
        setExcelState(false)
        const config = { withCredentials: true };
        if (reveal) {
            config.params = {
                reveal: true,
                reason: reason.trim(),
            };
        }

        await axios.get(process.env.REACT_APP_API + "/api/merchant/export-data", config)
            .then((response) => {
                let tmp = response?.data
                console.log(tmp)
                if (tmp?.code < 2000) {
                    excelData(tmp?.data ?? [], { reveal })
                } else {
                    alert(tmp?.msg || "엑셀 다운로드에 실패했습니다.");
                }
            }).catch(error => {
                console.error(error);
                navigate("/");
            }).finally(() => {
                setExcelState(true)
            });
    }

    const handleExcelDownloadClick = () => {
        if (canSelectMerchantExcelFormat) {
            setExcelDownloadType("masked")
            setExcelDownloadReason("")
            setExcelDownloadModal(true)
            return;
        }

        excelBtn();
    }

    const handleExcelDownloadConfirm = () => {
        const isRevealDownload = excelDownloadType === "reveal";
        if (isRevealDownload && excelDownloadReason.trim().length < 3) {
            alert("원문 형식 다운로드 사유는 3자 이상 입력해주세요.");
            return;
        }

        setExcelDownloadModal(false)
        excelBtn({
            reveal: isRevealDownload,
            reason: excelDownloadReason,
        });
    }

    const excelData = (exData, { reveal = false } = {}) => {
        let arr = []
        const useMaskedExcelSensitive = canSelectMerchantExcelFormat && !reveal;
        const excelSensitiveValue = (source, rawField, maskedField) => (
            useMaskedExcelSensitive ? (source?.[maskedField] ?? source?.[rawField] ?? "") : (source?.[rawField] ?? "")
        );

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let a = exData[i]?.agentHierarchy ?? []
                let m = exData[i]?.merchant ?? []
                let p = exData[i]?.pgInfo ?? []
                let s = exData[i]?.settlement ?? []

                try {
                    if (brand.tier === "sub") {
                        arr.push({
                            "등록일": m.reg_dt,
                            "사업자등록번호": m.co_no,
                            "가맹점ID": m.mid,
                            "상호명": m.co_nm,
                            "대표자명": m.boss_nm,
                            "연락처": excelSensitiveValue(m, "co_hp", "co_hp_masked"),
                            "사업장주소": m.co_addr,
                            // "빠른즉결사용": m.semi_realtime_yn,
                            "지사": a[0]?.agent_name ?? "",
                            "지사수수료": a[0]?.agent_fee ? Number(a[0].agent_fee) : "",
                            "총판": a[1]?.agent_name ?? "",
                            "총판수수료": a[1]?.agent_fee ? Number(a[1].agent_fee) : "",
                            "대리점": a[2]?.agent_name ?? "",
                            "대리점수수료": a[2]?.agent_fee ? Number(a[2].agent_fee) : "",
                            "영업자1": a[3]?.agent_name ?? "",
                            "영업자1수수료": a[3]?.agent_fee ? Number(a[3].agent_fee) : "",
                            "영업자2": a[4]?.agent_name ?? "",
                            "영업자2수수료": a[4]?.agent_fee ? Number(a[4].agent_fee) : "",
                            "영업자3": a[5]?.agent_name ?? "",
                            "영업자3수수료": a[5]?.agent_fee ? Number(a[5].agent_fee) : "",
                            "가맹점수수료": p.fee ? Number(p.fee) : "",
                            "정산은행": m.bank_nm,
                            "계좌번호": excelSensitiveValue(m, "accnt_no", "accnt_no_masked"),
                            "예금주": excelSensitiveValue(m, "accnt_nm", "accnt_nm_masked"),
                        })
                    } else {
                        arr.push({
                            "등록일": m.reg_dt,
                            "사업자등록번호": m.co_no,
                            "가맹점ID": m.mid,
                            "상호명": m.co_nm,
                            "대표자명": m.boss_nm,
                            "연락처": excelSensitiveValue(m, "co_hp", "co_hp_masked"),
                            "사업장주소": m.co_addr,
                            // "빠른즉결사용": m.semi_realtime_yn,
                            "지사": a[0]?.agent_name ?? "",
                            "지사수수료": a[0]?.agent_fee ? Number(a[0].agent_fee) : "",
                            "총판": a[1]?.agent_name ?? "",
                            "총판수수료": a[1]?.agent_fee ? Number(a[1].agent_fee) : "",
                            "대리점": a[2]?.agent_name ?? "",
                            "대리점수수료": a[2]?.agent_fee ? Number(a[2].agent_fee) : "",
                            "영업자1": a[3]?.agent_name ?? "",
                            "영업자1수수료": a[3]?.agent_fee ? Number(a[3].agent_fee) : "",
                            "영업자2": a[4]?.agent_name ?? "",
                            "영업자2수수료": a[4]?.agent_fee ? Number(a[4].agent_fee) : "",
                            "영업자3": a[5]?.agent_name ?? "",
                            "영업자3수수료": a[5]?.agent_fee ? Number(a[5].agent_fee) : "",
                            "가맹점수수료": p.fee ? Number(p.fee) : "",
                            "정산은행": m.bank_nm,
                            "계좌번호": excelSensitiveValue(m, "accnt_no", "accnt_no_masked"),
                            "예금주": excelSensitiveValue(m, "accnt_nm", "accnt_nm_masked"),
                            "바우처사용": m.deposit_yn,
                            "수기노출": m.sugi_expose,
                            "정산주기": s.settlement_cycle,
                            "적용일자": s.fr_dt,
                            "즉시여부": s.realtime_st_yn,
                            "정산지연분": s.realtime_delay_tm,
                            "PGMID": p.cat_id,
                        })
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
        setExcelState(true)
        Excel(arr, brand.tier, brand.excelPrefix, {
            formatLabel: canSelectMerchantExcelFormat ? (reveal ? "원문" : "마스킹") : "",
        })
    }

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    useEffect(() => {
        if (clickData && combineList.length > 0) {
            const found = combineList.find((d) => d.id == clickData.id);
            if (found) setClickData(found);
        }
    }, [combineList]);

    const tabList =
        MyData?.role === "SUPER"
            ? [
                "가맹점 수정",
                "정산주기",
                "PG정보",
                "수기결제 카드 정책",
                ...(clickData?.deposit_yn === "Y" ? ["지갑관리"] : []),
                ...(clickData?.urlpay === 1 ? ["URL결제 상품관리"] : []),
            ]
            : MyData?.role === "SM"
                ? ["가맹점 상세", "PG정보"]
                : ["가맹점 상세"];


    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0 || !hasMore) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && hasMore) {
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData, hasMore]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            {excelDownloadModal && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.35)",
                        zIndex: 10000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <div
                        style={{
                            width: "420px",
                            maxWidth: "calc(100vw - 32px)",
                            backgroundColor: "#fff",
                            borderRadius: "6px",
                            boxShadow: "0 12px 30px rgba(0, 0, 0, 0.18)",
                            padding: "20px",
                        }}
                    >
                        <div style={{ fontSize: "16px", fontWeight: "700", marginBottom: "8px" }}>
                            엑셀 다운로드 형식 선택
                        </div>
                        <div style={{ fontSize: "12px", color: "#666", marginBottom: "16px", lineHeight: 1.5 }}>
                            원문 형식은 민감정보가 포함되며 조회 사유가 필요합니다.
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "14px" }}>
                            <label style={{ display: "flex", gap: "8px", alignItems: "flex-start", cursor: "pointer" }}>
                                <input
                                    type="radio"
                                    name="excelDownloadType"
                                    value="masked"
                                    checked={excelDownloadType === "masked"}
                                    onChange={() => setExcelDownloadType("masked")}
                                />
                                <span>
                                    <strong>기존 형식</strong>
                                    <span style={{ display: "block", color: "#666", fontSize: "12px", marginTop: "2px" }}>
                                        계좌번호, 예금주, 연락처, 이메일이 마스킹된 엑셀입니다.
                                    </span>
                                </span>
                            </label>
                            <label style={{ display: "flex", gap: "8px", alignItems: "flex-start", cursor: "pointer" }}>
                                <input
                                    type="radio"
                                    name="excelDownloadType"
                                    value="reveal"
                                    checked={excelDownloadType === "reveal"}
                                    onChange={() => setExcelDownloadType("reveal")}
                                />
                                <span>
                                    <strong>원문 형식</strong>
                                    <span style={{ display: "block", color: "#b45309", fontSize: "12px", marginTop: "2px", fontWeight: "600" }}>
                                        민감정보 원문이 포함됩니다.
                                    </span>
                                </span>
                            </label>
                        </div>
                        {excelDownloadType === "reveal" && (
                            <div style={{ marginBottom: "16px" }}>
                                <label style={{ display: "block", fontSize: "12px", fontWeight: "600", marginBottom: "6px" }}>
                                    다운로드 사유
                                </label>
                                <input
                                    type="text"
                                    value={excelDownloadReason}
                                    onChange={(e) => setExcelDownloadReason(e.target.value)}
                                    placeholder="3자 이상 입력"
                                    style={{
                                        width: "100%",
                                        height: "36px",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        padding: "0 10px",
                                        outline: "none",
                                    }}
                                />
                            </div>
                        )}
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                            <button
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={() => setExcelDownloadModal(false)}
                                style={{ backgroundColor: "darkred", border: "none" }}
                            >
                                취소
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={handleExcelDownloadConfirm}
                            >
                                다운로드
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                    {<SearchSelectText type={"검색구분"} selectData={select4} handleSelectChange={handleSelectChange3} selectedValue={selectedValue3} handleSelectTextChange={handleSelectTextChange3} selectedText={selectedText3} btnText={"검색"} onClick={() => submit()} state={false} placeholder={"가맹점명 & MID & 에이전트명"} />}

                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ maxWidth: "430px", width: "100%" }}>
                        <div
                            className="tabulator_sorting_wrap"
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <CountAmountLeft tableBodyData={totalCount} />
                            {
                                MyData?.role == "SUPER"
                                    ?
                                    <div class="button_wrap separate" style={{ marginTop: "0px" }}>
                                        <SearchCrteateBtn type={"신규 등록"}
                                            onClick={() => {
                                                setUpdataeModal(false);
                                                setCreateModal(true);
                                                setClickData(null);
                                            }} />
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    {
                        MyData.role == "SUPER" || MyData.role == "SM"
                            ?
                            <div className='excel-disable'>
                                <DownloadBtn text={"엑셀 다운로드"} onClick={handleExcelDownloadClick} state={excelState} />
                            </div>
                            :
                            ""
                    }
                </div>
                <div className='div-flex-2'>
                    <div style={{ maxWidth: "436px", width: "100%" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={combineList ?? []}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            clickData={clickData}
                            onRowClick={handleRowClick}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"700px"}
                        />
                    </div>
                    {
                        !createModal && !updateModal && !clickData && (
                            <div className='mt-3 div-flex-2-1' style={{ border: "8px solid #454545", height: "740px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold", color: "gray" }}>
                                가맹점을 선택해주세요
                            </div>
                        )
                    }
                    {createModal && MyData?.role == "SUPER" && (
                        <div className='mt-3 div-flex-2-1' style={{ border: "8px solid #575757", width: "100%" }}>
                            <div style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "0 10px",
                                borderBottom: "1px solid #E5E5E5",
                                backgroundColor: "#fff"
                            }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    {["가맹점 등록"].map((tab) => (
                                        <button
                                            key={tab}
                                            className={`tab-btn active`}
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                <CreateInfo
                                    setMessage={setMessage}
                                    setReload={setReload}
                                />
                            </div>
                        </div>
                    )}

                    {updateModal && clickData && (
                        <div className='mt-3 div-flex-2-1' style={{ border: "8px solid #454545", height: "auto" }}>
                            <div style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "0 10px",
                                borderBottom: "1px solid #E5E5E5",
                                backgroundColor: "#fff"
                            }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    {tabList.map((tab) => (
                                        <button
                                            key={tab}
                                            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                            onClick={() => handleClickTab(tab)}
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: activeTab === tab ? "600" : "400",
                                                color: activeTab === tab ? "#222" : "#888",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                                {MyData?.role === "SUPER" && clickData?.mid && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => setAuditModal(true)}
                                        style={{
                                            height: "30px",
                                            fontSize: "12px",
                                            padding: "0 10px",
                                            whiteSpace: "nowrap",
                                            marginRight: "10px",
                                        }}
                                    >
                                        변경 이력
                                    </button>
                                )}
                                {/* {
                                    MyData?.role == "SUPER"
                                        ?
                                        <div class="button_wrap separate" style={{ marginTop: "0px" }}>
                                            <SearchCrteateBtn type={"신규 등록"}
                                                onClick={() => {
                                                    setUpdataeModal(false);
                                                    setCreateModal(true);
                                                    setClickData(null);
                                                }} />
                                        </div>
                                        :
                                        ""
                                } */}
                            </div>

                            {/* ▼ 탭 내용 */}
                            <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                {(activeTab === "가맹점 수정" || activeTab === "가맹점 상세") && clickData?.id && (
                                    <div>
                                        <UpdateInfo
                                            key={clickData?.id || ""}  // ← 추가됨: key로 id 사용
                                            setMessage={setMessage}
                                            clickData={clickData}
                                            setReload={setReload}
                                            level={level}
                                        />
                                    </div>
                                )}
                                {activeTab === "정산주기" && clickData?.id && (
                                    <div style={{ width: "100%" }}>
                                        <div style={{ width: "100%" }}>
                                            <PaymentInfo
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        </div>
                                    </div>
                                )}
                                {activeTab === "PG정보" && clickData?.id && (
                                    <div style={{ width: "100%" }}>
                                        <div style={{ width: "100%" }}>
                                            <PGInfo
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        </div>
                                    </div>
                                )}
                                {activeTab === "수기결제 카드 정책" && clickData?.id && (
                                    <div style={{ width: "100%", padding: "12px 0" }}>
                                        <ManualCardPolicySection
                                            mid={clickData?.mid}
                                            merchantName={clickData?.co_nm}
                                            merchant={clickData}
                                            canEdit={MyData?.role === "SUPER"}
                                            setMessage={setMessage}
                                            setReload={setReload}
                                        />
                                    </div>
                                )}
                                {activeTab === "지갑관리" && clickData?.id && (
                                    <div style={{ width: "100%" }}>
                                        <div style={{ width: "100%" }}>
                                            <Wallet
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        </div>
                                    </div>
                                )}
                                {activeTab === "URL결제 상품관리" && clickData?.id && (
                                    <div style={{ width: "100%" }}>
                                        <div style={{ width: "100%" }}>
                                            <URLPayment
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {auditModal && clickData?.mid && (
                <AuditModal mid={clickData.mid} onClose={() => setAuditModal(false)} />
            )}
        </div>
    )
}

function AuditModal({ mid, onClose }) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 100000,
            }}
            onClick={onClose}
        >
            <div
                style={{
                    width: '90vw',
                    maxWidth: '1100px',
                    height: '85vh',
                    background: '#fff',
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 18px', borderBottom: '1px solid #e5e5e5', flexShrink: 0 }}>
                    <h2 style={{ fontSize: '16px', fontWeight: 'bold', margin: 0 }}>
                        변경 이력 <span style={{ color: '#888', fontWeight: 400, fontSize: '13px' }}>· 가맹점 {mid}</span>
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="닫기"
                        style={{ background: 'transparent', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#666', padding: 0 }}
                    >
                        ×
                    </button>
                </div>
                <div style={{ flex: 1, minHeight: 0, overflow: 'auto', padding: '12px 18px' }}>
                    <MerchantAuditView mid={mid} showFilterChip={false} detailMode="inline" />
                </div>
            </div>
        </div>
    );
}

function CreateInfo({ setMessage, setReload }) {
    const { Rwidth, Rheight } = useWindowSize();

    // 현재 로그인 사용자 정보 (role 체크용)
    const MyData = useSelector((state) => state.MyData);

    // 상위(영업자) 리스트
    const [levelData, setLevelData] = useState([]);

    // 폼 데이터 (UpdateInfo와 동일 항목들 추가)
    const initialFormData = {
        영업자: "",
        사업자등록번호: "",
        상호명: "",
        대표자명: "",
        연락처: "",
        사업장주소: "",
        가맹점ID: "",

        // 수수료 관련
        수수료계산기준: "절사",     // (ex) '절사' or '반올림'
        수수료등록기준: "VAT포함",  // (ex) 'VAT포함' or 'VAT미포함'

        // 은행/계좌 관련
        정산은행: "",
        예금주: "",
        계좌번호: "",

        // 기능 설정
        취소기능: "가능",          // (ex) '가능', '불가능', '당일만가능'
        부가세표시: "별도표시",     // (ex) '별도표시', '미표시'
        결제공지: "미공지",        // (ex) '미공지', 'SMS공지'
        상태: "0",                 // (ex) '0' = 중지, '1' = 사용 등?

        // 수수료 구조 (지사/총판/대리점)
        지사: "",
        지사수수료: "",
        총판: "",
        총판수수료: "",
        대리점: "",
        대리점수수료: "",
        영업자1: "",
        영업자1수수료: "",
        영업자2: "",
        영업자2수수료: "",
        영업자3: "",
        영업자3수수료: "",
        가맹점수수료: "",

        // 세금계산서
        세금계산서Email: "",
        바우처사용: "N",
        출금수수료상속: true,
        출금수수료: '',
        정산형태: "Y",

        // 신규로 추가: 일/월 한도, 불가카드, 수기노출, 등등
        일한도: "",
        월한도: "",
        불가카드: [],
        수기노출: "N",            // (ex) 'Y' or 'N'
        동일카드일일수기결제제한: "N",
        동일카드일일수기결제허용횟수: "1",

        // 아래 필드들은 UpdateInfo에서 쓰이는 항목(등록 API에서 안 쓰면 제거 가능)
        비고: "",
        사용여부: "사용",           // (ex) '사용', '중지' 등?
        부분취소사용여부: "사용",   // (ex) '사용', '중지' 등?
        단말기취소사용여부: "사용", // (ex) '사용', '중지' 등?
        수기취소사용여부: "사용",   // (ex) '사용', '중지' 등?
        할부제한: "0",             // (ex) '0'=일시불만, '3'=3개월 가능 등
        입금적요: "",
        단말기비부과: isFastBrand() ? "N" : "Y", // fast 기본 미부과
        단말기비부과시점: DEFAULT_TERMINAL_FEE_APPLY_TYPE,
        익일정산생략: "N",         // "Y" = 익일정산, "N" = 미처리
    };

    const [formData, setFormData] = useState(initialFormData);

    // 중복 클릭 방지용
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 예금주 조회
    const { verifying: verifyingHolder, isVerified: holderVerified, verify: verifyHolder } =
        useAccountHolderVerify({ formData, setFormData, setMessage });


    // (1) 상위리스트 (영업자) 불러오기
    useEffect(() => {
        LevelList();
    }, []);

    const LevelList = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + `/api/merchant/agent-list`,
                { withCredentials: true }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setLevelData(
                    (tmp?.data?.agent ?? []).sort((a, b) => a.auth_cd - b.auth_cd)
                );
            } else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "상위리스트 조회 중 오류가 발생했습니다." });
        }
    };

    // 영업자 선택 시 (지사/총판/대리점/수수료) 자동 세팅하고 싶다면,
    // UpdateInfo처럼 agentUpdateList 로직을 추가하면 됩니다. (프로젝트 상황에 맞춰 자유롭게)    
    useEffect(() => {
        agentUpdateList(formData.영업자, "Y")
    }, [formData.영업자])

    const agentUpdateList = async (agent, type) => {
        if (!agent) return;
        await axios.get(process.env.REACT_APP_API + `/api/merchant/up-list`, {
            params: {
                code: agent,
            },
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                let listArr = tmp?.data?.agent
                setFormData((prevFormData) => {
                    return {
                        ...prevFormData,
                        지사: listArr[0]?.agent_name || "",
                        지사수수료: listArr[0] ? Number(listArr[0].agent_fee) : "",
                        총판: listArr[1]?.agent_name || "",
                        총판수수료: listArr[1] ? Number(listArr[1].agent_fee) : "",
                        대리점: listArr[2]?.agent_name || "",
                        대리점수수료: listArr[2] ? Number(listArr[2].agent_fee) : "",
                        영업자1: listArr[3]?.agent_name || "",
                        영업자1수수료: listArr[3] ? Number(listArr[3].agent_fee) : "",
                        영업자2: listArr[4]?.agent_name || "",
                        영업자2수수료: listArr[4] ? Number(listArr[4].agent_fee) : "",
                        영업자3: listArr[5]?.agent_name || "",
                        영업자3수수료: listArr[5] ? Number(listArr[5].agent_fee) : "",
                    };
                });
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    // (2) 폼 입력 변경
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        // 체크박스(배열) 처리
        if (type === "checkbox") {
            setFormData((prev) => {
                const 기존 = prev[name] || [];
                return {
                    ...prev,
                    [name]: checked
                        ? [...기존, value]
                        : 기존.filter((item) => item !== value),
                };
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // (3) 등록 버튼
    const onSubmit = async () => {
        if (isSubmitting) return; // 중복 막기
        setIsSubmitting(true);

        try {
            // 등록 API에 동일한 필드를 보내려면, UpdateInfo와 비슷하게 작성
            // (API에서 사용하지 않는 필드는 빼도 됩니다.)
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/merchant/regist",
                {
                    // 기존 필드
                    upId: formData.영업자,
                    co_no: formData.사업자등록번호,
                    boss_nm: formData.대표자명,
                    tax_email: formData.세금계산서Email,
                    co_nm: formData.상호명,
                    co_hp: formData.연락처,
                    co_addr: formData.사업장주소,
                    bank_nm: formData.정산은행,
                    accnt_nm: formData.예금주,
                    accnt_no: formData.계좌번호,
                    mid: formData.가맹점ID,
                    수수료계산기준: formData.수수료계산기준,
                    수수료등록기준: formData.수수료등록기준,
                    vat_disp_yn: formData.부가세표시,
                    noti_pay_type: formData.결제공지,
                    취소기능: formData.취소기능,
                    상태: formData.상태,
                    worker: "admin", // 예시
                    deposit_yn: formData.바우처사용,
                    semi_realtime_yn: formData.정산형태,

                    block_card: formData.불가카드.join(","),      // 불가카드
                    day_limit: formData.일한도,
                    month_limit: formData.월한도,
                    card_part_cancel_yn: formData.부분취소사용여부,
                    card_cancel_yn: formData.단말기취소사용여부,
                    cat_cancel_yn: formData.수기취소사용여부,
                    card_inst: formData.할부제한,
                    etc: formData.비고,
                    use_yn: formData.사용여부,      // 등록 API에서 실제 사용하는지 확인 필요
                    card_use_yn: formData.사용여부, // 동일
                    sugi_expose: formData.수기노출,
                    payout_memo: formData.입금적요,
                    terminal_fee_yn: formData.단말기비부과,
                    payout_hold_yn: formData.익일정산생략,
                    ...buildManualSameCardLimitPayload(formData),

                    // up_data:""
                    // 지사/총판/대리점/수수료 부분도 추가 전송할 경우,
                    //   -> 프로젝트 로직에 맞춰 별도 처리 (agent hierarchy 등)
                },
                { withCredentials: true }
            );

            const tmp = response?.data;
            if (tmp?.code < 2000) {
                let terminalFeeMessage = "";
                try {
                    terminalFeeMessage = await saveFastTerminalFeeExemption(formData.가맹점ID, formData, initialFormData);
                } catch (error) {
                    terminalFeeMessage = error.message;
                }
                setMessage({ msg: terminalFeeMessage ? `가맹점 등록에 성공했습니다. ${terminalFeeMessage}` : "가맹점 등록에 성공했습니다." });
                setReload((e) => !e);
                setFormData(initialFormData);
            } else {
                setMessage({ msg: tmp?.msg ?? "에이전트 등록에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "가맹점 등록 중 오류가 발생했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        setFormData(initialFormData);
    };

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div
                        style={{
                            padding: "0 0 0.5rem",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: "flex",
                            gap: "20px",
                        }}
                    >
                        <div className="list-info-box" style={{ width: "100%" }}>
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        {/* 1) 사업자/상호/대표자/연락처 */}
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    사업자등록번호
                                                </span>
                                                <input
                                                    name="사업자등록번호"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.사업자등록번호}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    MID
                                                    {/* <span style={{ color: "red", fontSize: "10px", marginLeft: "3px", paddingTop: "3px" }}>*</span> */}
                                                </span>
                                                <input
                                                    name="가맹점ID"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.가맹점ID}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    상호명
                                                </span>
                                                <input
                                                    name="상호명"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.상호명}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    대표자명
                                                </span>
                                                <input
                                                    name="대표자명"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.대표자명}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </li>

                                        {/* 2) 사업장주소 */}
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    연락처
                                                </span>
                                                <input
                                                    name="연락처"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.연락처}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    사업장주소
                                                </span>
                                                <input
                                                    name="사업장주소"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.사업장주소}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            {/* <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    빠른즉결사용
                                                </span>
                                                <select
                                                    id="정산형태"
                                                    name="정산형태"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.정산형태}
                                                    onChange={handleChange}
                                                >
                                                    <option value="Y">Y</option>
                                                    <option value="N">N</option>
                                                </select>
                                            </div> */}
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    지갑 사용
                                                </span>
                                                <select
                                                    id="바우처사용"
                                                    name="바우처사용"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.바우처사용}
                                                    onChange={handleChange}
                                                >
                                                    <option value="Y">Y</option>
                                                    <option value="N">N</option>
                                                </select>
                                            </div>
                                        </li>

                                        {formData.바우처사용 === "Y" && (
                                        <li>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    data-tooltip-id="withdrawal-fee-tooltip"
                                                    data-tooltip-html="체크 시: 상위(에이전트/시스템) 설정값을 그대로 적용합니다.<br/>체크 해제 시: 직접 입력한 금액이 적용됩니다.<br/>0 입력 시 출금 수수료 무료."
                                                    style={{ width: "110px", height: "34px", cursor: "help" }}
                                                >
                                                    출금 수수료
                                                    <Tooltip id="withdrawal-fee-tooltip" place="top" style={{ fontSize: "12px", maxWidth: "220px", lineHeight: "1.8", zIndex: 100000 }} />
                                                </span>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "calc(100% - 112px)", paddingLeft: "6px" }}>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "0.7rem", whiteSpace: "nowrap", cursor: "pointer" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={formData.출금수수료상속}
                                                            onChange={(e) => setFormData(prev => ({
                                                                ...prev,
                                                                출금수수료상속: e.target.checked,
                                                                출금수수료: e.target.checked ? '' : prev.출금수수료,
                                                            }))}
                                                        />
                                                        상위 상속
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className="right-text"
                                                        style={{ flex: 1, border: "none", outline: "none", fontSize: "0.7rem", color: "#646464", backgroundColor: formData.출금수수료상속 ? "#f5f5f5" : "" }}
                                                        disabled={formData.출금수수료상속}
                                                        value={formData.출금수수료상속 ? '' : formData.출금수수료}
                                                        placeholder={formData.출금수수료상속 ? (formData.출금수수료적용값 != null ? `상위 상속 중 (적용값: ${formData.출금수수료적용값}원)` : "상위 상속 중") : "0"}
                                                        onChange={(e) => setFormData(prev => ({ ...prev, 출금수수료: e.target.value }))}
                                                    />
                                                </div>
                                            </div>
                                        </li>
                                        )}

                                        {/* 3) 영업자 + 수기노출 */}
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    영업자
                                                </span>
                                                <select
                                                    id="영업자"
                                                    name="영업자"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.영업자}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">선택</option>
                                                    {levelData.map((a, i) => {
                                                        const agentType =
                                                            a.auth_cd === 1
                                                                ? "지사"
                                                                : a.auth_cd === 2
                                                                    ? "총판"
                                                                    : a.auth_cd === 3
                                                                        ? "대리점"
                                                                        : a.auth_cd === 4
                                                                            ? "영업자1"
                                                                            : a.auth_cd === 5
                                                                                ? "영업자2"
                                                                                : "영업자3"
                                                        const optionLabel = `(${agentType}) ${a.nm}`;
                                                        return (
                                                            <option key={i} value={a.code}>
                                                                {optionLabel}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    수기노출
                                                </span>
                                                <select
                                                    id="수기노출"
                                                    name="수기노출"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.수기노출}
                                                    onChange={handleChange}
                                                >
                                                    <option value="Y">Y</option>
                                                    <option value="N">N</option>
                                                </select>
                                            </div>
                                        </li>
                                        {/* 4) 지사, 총판, 대리점 + 수수료 */}
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    지사
                                                </span>
                                                <input
                                                    name="지사"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.지사}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    지사수수료
                                                </span>
                                                <input
                                                    name="지사수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.지사수수료}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    총판
                                                </span>
                                                <input
                                                    name="총판"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.총판}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    총판수수료
                                                </span>
                                                <input
                                                    name="총판수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.총판수수료}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    대리점
                                                </span>
                                                <input
                                                    name="대리점"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.대리점}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    대리점수수료
                                                </span>
                                                <input
                                                    name="대리점수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.대리점수수료}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    영업자1
                                                </span>
                                                <input
                                                    name="영업자1"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.영업자1}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    영업자1수수료
                                                </span>
                                                <input
                                                    name="영업자1수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.영업자1수수료}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    영업자2
                                                </span>
                                                <input
                                                    name="영업자2"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.영업자2}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    영업자2수수료
                                                </span>
                                                <input
                                                    name="영업자2수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.영업자2수수료}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    영업자3
                                                </span>
                                                <input
                                                    name="영업자3"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.영업자3}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    영업자3수수료
                                                </span>
                                                <input
                                                    name="영업자3수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.영업자3수수료}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>

                                        {/* 5) 은행, 예금주, 계좌번호, 세금계산서Email */}
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    가맹점수수료
                                                </span>
                                                <input
                                                    name="가맹점수수료"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.가맹점수수료}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    정산은행
                                                </span>
                                                <select
                                                    id="정산은행"
                                                    name="정산은행"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.정산은행}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">선택</option>
                                                    {bank.map((a, i) => (
                                                        <option key={i} value={a.name}>
                                                            {a.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    계좌번호
                                                </span>
                                                <input
                                                    name="계좌번호"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px - 76px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.계좌번호}
                                                    onChange={handleChange}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={verifyHolder}
                                                    disabled={verifyingHolder}
                                                    style={verifyBtnStyle(verifyingHolder)}
                                                >
                                                    {verifyingHolder ? "조회중" : "계좌 확인"}
                                                </button>
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    예금주
                                                </span>
                                                <input
                                                    name="예금주"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: holderVerified ? "calc(100% - 112px - 60px)" : "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.예금주}
                                                    onChange={handleChange}
                                                />
                                                {holderVerified && (
                                                    <span style={verifiedBadgeStyle}>확인됨</span>
                                                )}
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    입금적요
                                                </span>
                                                <input
                                                    name="입금적요"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.입금적요}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </li>

                                        {canManageMerchantTerminalFee(MyData) && isTerminalFeeSettingBrand() && (
                                        <li className='mobile'>
                                            <div className="inner" style={{ alignItems: "flex-start", minHeight: isTerminalFeeEnabledFromOff(formData, initialFormData) ? "154px" : "34px" }}>
                                                <span className="left-text" style={{ width: "110px", height: "34px", display: "flex", alignItems: "center" }}>
                                                    단말기비 부과
                                                </span>
                                                <div style={{ width: "calc(100% - 112px)", padding: "0 8px" }}>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", height: "34px", fontSize: "12px", cursor: "pointer" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={formData.단말기비부과 === "Y"}
                                                            onChange={(e) => setFormData(prev => ({
                                                                ...prev,
                                                                단말기비부과: e.target.checked ? "Y" : "N",
                                                                단말기비부과시점: e.target.checked ? (prev.단말기비부과시점 || DEFAULT_TERMINAL_FEE_APPLY_TYPE) : DEFAULT_TERMINAL_FEE_APPLY_TYPE,
                                                            }))}
                                                            style={{ width: "14px", height: "14px", cursor: "pointer" }}
                                                        />
                                                        {formData.단말기비부과 === "Y"
                                                            ? "정산금에서 차감"
                                                            : <span style={{ color: "#dc3545", fontWeight: "600" }}>미부과</span>
                                                        }
                                                    </label>
                                                    {isTerminalFeeEnabledFromOff(formData, initialFormData) && (
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "5px", padding: "2px 0 8px", fontSize: "12px" }}>
                                                            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                                                                <input
                                                                    type="radio"
                                                                    name="create_terminal_fee_apply_type"
                                                                    checked={formData.단말기비부과시점 === CURRENT_TERMINAL_FEE_APPLY_TYPE}
                                                                    onChange={() => setFormData(prev => ({ ...prev, 단말기비부과시점: CURRENT_TERMINAL_FEE_APPLY_TYPE }))}
                                                                />
                                                                이번달부터 부과
                                                            </label>
                                                            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                                                                <input
                                                                    type="radio"
                                                                    name="create_terminal_fee_apply_type"
                                                                    checked={formData.단말기비부과시점 !== CURRENT_TERMINAL_FEE_APPLY_TYPE}
                                                                    onChange={() => setFormData(prev => ({ ...prev, 단말기비부과시점: DEFAULT_TERMINAL_FEE_APPLY_TYPE }))}
                                                                />
                                                                다음달부터 부과
                                                            </label>
                                                            <TerminalFeePolicyGuide formData={formData} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                        )}

                                        {getBrand().key !== "fast" && (
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px", display: "flex", alignItems: "center" }}>
                                                    익일정산 생략
                                                </span>
                                                <label style={{ display: "flex", alignItems: "center", gap: "8px", padding: "0 8px", height: "34px", fontSize: "12px", cursor: "pointer" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={formData.익일정산생략 === "Y"}
                                                        onChange={(e) => setFormData(prev => ({ ...prev, 익일정산생략: e.target.checked ? "Y" : "N" }))}
                                                        style={{ width: "14px", height: "14px", cursor: "pointer" }}
                                                    />
                                                    {formData.익일정산생략 === "Y"
                                                        ? <span style={{ color: "#dc3545", fontWeight: "600" }}>생략</span>
                                                        : "정상"
                                                    }
                                                </label>
                                            </div>
                                        </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 하단 버튼 */}
                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={() => onSubmit()}
                            disabled={isSubmitting}
                        >
                            등록
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={handleCancel}
                            style={{ backgroundColor: "darkred", marginLeft: "10px", border: "none" }}
                            value="취소"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function UpdateInfo({ setMessage, clickData, setReload, level }) {
    let MyData = useSelector((state) => { return state.MyData })

    const [levelData, setLevelData] = useState([])

    // ▼ 추가: 수정 버튼 중복 방지용 상태
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isTerminating, setIsTerminating] = useState(false);

    const isTerminated = !!clickData?.terminated_at;
    const canRevealMerchantSensitive = getBrand().key === "baekma" && MyData?.admin_id === "test";
    const [revealedSensitive, setRevealedSensitive] = useState(null);
    const [sensitiveLoading, setSensitiveLoading] = useState(false);
    const sensitiveTimerRef = useRef(null);
    const sensitiveRevealed = !!revealedSensitive;

    useEffect(() => {
        return () => {
            if (sensitiveTimerRef.current) clearTimeout(sensitiveTimerRef.current);
        };
    }, []);

    const pickSensitive = (source, field, maskedField) => (
        canRevealMerchantSensitive ? (source?.[maskedField] ?? source?.[field] ?? "") : (source?.[field] ?? "")
    );

    const applySensitiveToForm = (sensitive) => {
        setFormData(prev => ({
            ...prev,
            연락처: sensitive?.co_hp ?? prev.연락처,
            계좌번호: sensitive?.accnt_no ?? prev.계좌번호,
            예금주: sensitive?.accnt_nm ?? prev.예금주,
            세금계산서Email: sensitive?.tax_email ?? prev.세금계산서Email,
        }));
    };

    const revealSensitive = async () => {
        if (!canRevealMerchantSensitive || !clickData?.id || sensitiveLoading) return;

        const reason = window.prompt('가맹점 민감정보 원문 조회 사유를 입력해주세요. (3자 이상)');
        if (reason === null) return;
        if (reason.trim().length < 3) {
            alert('조회 사유는 3자 이상 입력해주세요.');
            return;
        }

        setSensitiveLoading(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/merchant/reveal-sensitive",
                { ids: [clickData.id], reason: reason.trim() },
                { withCredentials: true }
            );
            const tmp = response?.data;
            if (tmp?.code === 1000) {
                const sensitive =
                    tmp?.data?.merchants?.[0] ||
                    tmp?.data?.sensitive?.[0] ||
                    tmp?.data?.merchant ||
                    tmp?.data;

                if (!sensitive) {
                    alert('조회된 원문 정보가 없습니다.');
                    return;
                }

                setRevealedSensitive(sensitive);
                applySensitiveToForm(sensitive);

                if (sensitiveTimerRef.current) clearTimeout(sensitiveTimerRef.current);
                const expiresIn = Number(tmp?.data?.expires_in || 60);
                sensitiveTimerRef.current = setTimeout(() => {
                    setRevealedSensitive(null);
                    const maskedInitial = makeInitialFormData(clickData);
                    setFormData(prev => ({
                        ...prev,
                        연락처: maskedInitial.연락처,
                        계좌번호: maskedInitial.계좌번호,
                        예금주: maskedInitial.예금주,
                        세금계산서Email: maskedInitial.세금계산서Email,
                    }));
                    sensitiveTimerRef.current = null;
                }, expiresIn * 1000);
            } else {
                alert(tmp?.msg || '가맹점 민감정보 원문 조회에 실패했습니다.');
            }
        } catch (error) {
            console.error('가맹점 민감정보 원문 조회 오류:', error);
            alert('가맹점 민감정보 원문 조회 중 오류가 발생했습니다.');
        } finally {
            setSensitiveLoading(false);
        }
    };

    // ▼ 초기 clickAgent 계산 함수
    const getLowestAgentCode = (cd) => {
        if (!cd?.agent_hierarchy?.length) return null;
        const lowestAgent = cd.agent_hierarchy.reduce((min, item) => {
            return item.level < min.level ? item : min;
        }, cd.agent_hierarchy[0]);
        return lowestAgent ? lowestAgent.agent_code : null;
    };

    // ▼ 초기 clickAgentData
    const [originalClickAgentData, setOriginalClickAgentData] = useState(clickData.agent_hierarchy);

    // ▼ 실제 상태
    const [clickAgent, setClickAgent] = useState(getLowestAgentCode(clickData));
    const [clickAgentData, setClickAgentData] = useState(clickData.agent_hierarchy);

    // ▼ 초기 formData 생성 함수
    const makeInitialFormData = (cd) => {
        const lowestAgent = cd.agent_hierarchy?.length > 0
            ? cd.agent_hierarchy.reduce((min, item) => {
                return item.level < min.level ? item : min;
            }, cd.agent_hierarchy[0])
            : null;

        const 영업자 = lowestAgent
            ? `(${(lowestAgent.agent_code?.length ?? 0) / 2 === 6
                ? "영업자3"
                : (lowestAgent.agent_code?.length ?? 0) / 2 === 5
                    ? "영업자2"
                    : (lowestAgent.agent_code?.length ?? 0) / 2 === 4
                        ? "영업자1"
                        : (lowestAgent.agent_code?.length ?? 0) / 2 === 3
                            ? "대리점"
                            : (lowestAgent.agent_code?.length ?? 0) / 2 === 2
                                ? "총판"
                                : "지사"}) ${lowestAgent.name ?? ""}`
            : '';

        return {
            영업자,
            지사: cd?.agent_hierarchy?.find(agent => (agent.agent_code?.length ?? 0) / 2 === 1)?.name ?? '',
            총판: cd?.agent_hierarchy?.find(agent => (agent.agent_code?.length ?? 0) / 2 === 2)?.name ?? '',
            대리점: cd?.agent_hierarchy?.find(agent => (agent.agent_code?.length ?? 0) / 2 === 3)?.name ?? '',
            영업자1: cd?.agent_hierarchy?.find(agent => (agent.agent_code?.length ?? 0) / 2 === 4)?.name ?? '',
            영업자2: cd?.agent_hierarchy?.find(agent => (agent.agent_code?.length ?? 0) / 2 === 5)?.name ?? '',
            영업자3: cd?.agent_hierarchy?.find(agent => (agent.agent_code?.length ?? 0) / 2 === 6)?.name ?? '',

            지사수수료: "",
            총판수수료: "",
            대리점수수료: "",
            영업자1수수료: "",
            영업자2수수료: "",
            영업자3수수료: "",
            가맹점수수료: Number(cd?.merchant_fee),

            바우처사용: cd?.deposit_yn ?? '',
            출금수수료상속: cd?.withdrawal_fee === null || cd?.withdrawal_fee === undefined,
            출금수수료: cd?.withdrawal_fee ?? '',
            출금수수료적용값: cd?.effective_withdrawal_fee,
            정산형태: cd?.semi_realtime_yn ?? "",

            사업자등록번호: cd?.co_no ?? "",
            상호명: cd?.co_nm ?? "",
            대표자명: cd?.boss_nm ?? "",
            연락처: pickSensitive(cd, 'co_hp', 'co_hp_masked'),
            사업장주소: cd?.co_addr ?? "",
            가맹점ID: cd?.mid ?? "",
            수수료계산기준: cd?.mid ?? '절사', // 기본값
            수수료등록기준: cd?.fee_vat_yn ?? 'VAT포함', // 기본값
            정산은행: cd?.bank_nm ?? "",
            취소기능: cd?.cancel_yn ?? '가능', // 기본값
            예금주: pickSensitive(cd, 'accnt_nm', 'accnt_nm_masked'),
            계좌번호: pickSensitive(cd, 'accnt_no', 'accnt_no_masked'),
            세금계산서Email: pickSensitive(cd, 'tax_email', 'tax_email_masked'),
            부가세표시: cd?.vat_disp_yn ?? '별도표시', // 기본값
            결제공지: cd?.noti_pay_type ?? '미공지', // 기본값
            상태: '0', // 기본값: 중지
            비고: cd?.etc ?? '',
            불가카드: cd?.block_card?.split(',') ?? [],
            사용여부: cd?.use_yn ?? '사용', // 기본값
            부분취소사용여부: cd?.card_part_cancel_yn ?? '사용', // 기본값
            단말기취소사용여부: cd?.card_cancel_yn ?? '사용', // 기본값
            수기취소사용여부: cd?.cat_cancel_yn ?? '사용', // 기본값
            할부제한: cd?.card_inst ?? '0', // 기본값: 일시불
            일한도: cd?.day_limit ?? '',
            월한도: cd?.month_limit ?? '',
            수기노출: cd?.sugi_expose ?? 'N',
            동일카드일일수기결제제한: cd?.manual_same_card_limit_yn ?? 'N',
            동일카드일일수기결제허용횟수: String(normalizeManualSameCardDailyLimit(cd?.manual_same_card_daily_limit)),
            등록일: cd?.reg_dt ?? '',
            수정일: cd?.mod_dt ?? '',
            입금적요: cd?.payout_memo ?? '',
            단말기비부과: cd?.terminal_fee_yn ?? 'N',
            단말기비부과시점: cd?.terminal_fee_apply_type ?? DEFAULT_TERMINAL_FEE_APPLY_TYPE,
            익일정산생략: cd?.payout_hold_yn ?? 'N',
            즉시적용: false,
        };
    };

    // ▼ 초기 formData
    const initialFormData = makeInitialFormData(clickData);

    // ▼ 실제 formData 상태
    const [formData, setFormData] = useState(initialFormData);

    // ▼ "기본값" 보관: (사용자가 "취소" 누르면 이 값으로 되돌림)
    const [originalFormData, setOriginalFormData] = useState(initialFormData);

    // ▼ clickData 변경될 때마다 초기 상태 다시 세팅
    useEffect(() => {
        setRevealedSensitive(null);
        if (sensitiveTimerRef.current) {
            clearTimeout(sensitiveTimerRef.current);
            sensitiveTimerRef.current = null;
        }

        // 1) agent 하위 리스트 다시 세팅
        setClickAgent(getLowestAgentCode(clickData));
        setClickAgentData(clickData.agent_hierarchy);
        setOriginalClickAgentData(clickData.agent_hierarchy);

        // 2) formData(및 originalFormData) 다시 생성
        const newInitial = makeInitialFormData(clickData);
        setFormData(newInitial);
        setOriginalFormData(newInitial);

        // 3) agentUpdateList 재실행
        agentUpdateList(getLowestAgentCode(clickData), "Y");
    }, [clickData]); // <-- clickData 바뀔 때마다

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prevFormData) => {
                const updatedCheckboxes = checked
                    ? [...prevFormData[name], value]
                    : prevFormData[name].filter((item) => item !== value);
                return { ...prevFormData, [name]: updatedCheckboxes };
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleChangeAgent = (id) => {
        agentUpdateList(id, "N")
    }

    useEffect(() => {
        LevelList()
    }, [])

    // ▼ 기존: clickAgent 초기 세팅
    useEffect(() => {
        agentUpdateList(clickAgent, "Y")
    }, [])

    const agentUpdateList = async (agent, type) => {
        if (!agent) return;
        await axios.get(process.env.REACT_APP_API + `/api/merchant/up-list`, {
            params: {
                code: agent,
                mid: type === "Y" ? clickData.mid : ""
            },
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                let listArr = tmp?.data?.agent
                setClickAgentData(listArr)
                setFormData((prevFormData) => {
                    return {
                        ...prevFormData,
                        지사: listArr[0]?.agent_name || "",
                        지사수수료: listArr[0] ? Number(listArr[0].agent_fee) : "",
                        총판: listArr[1]?.agent_name || "",
                        총판수수료: listArr[1] ? Number(listArr[1].agent_fee) : "",
                        대리점: listArr[2]?.agent_name || "",
                        대리점수수료: listArr[2] ? Number(listArr[2].agent_fee) : "",
                        영업자1: listArr[3]?.agent_name || "",
                        영업자1수수료: listArr[3] ? Number(listArr[3].agent_fee) : "",
                        영업자2: listArr[4]?.agent_name || "",
                        영업자2수수료: listArr[4] ? Number(listArr[4].agent_fee) : "",
                        영업자3: listArr[5]?.agent_name || "",
                        영업자3수수료: listArr[5] ? Number(listArr[5].agent_fee) : "",
                    };
                });
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const LevelList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/merchant/agent-list`, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data

            if (tmp?.code < 2000) {
                setLevelData(
                    (tmp?.data?.agent ?? []).sort((a, b) => a.auth_cd - b.auth_cd)
                );
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const onSubmit = async () => {
        // 중복 클릭 방지
        if (isSubmitting) return;
        if (canRevealMerchantSensitive && !sensitiveRevealed) {
            setMessage({ msg: "민감정보 원문 조회 후 수정할 수 있습니다." });
            return;
        }
        setIsSubmitting(true);

        try {
            let agentArr = []
            if (clickAgentData) {

                for (let i = 0; i < clickAgentData.length; i++) {
                    let data = clickAgentData[i]
                    agentArr.push({
                        "fid": data.agent_id,
                        "lv": clickAgentData.length - i,
                        "fee": data.auth_cd === 1 ? Number(formData.지사수수료)
                            : data.auth_cd === 2 ? Number(formData.총판수수료)
                                : data.auth_cd === 3 ? Number(formData.대리점수수료)
                                    : data.auth_cd === 4 ? Number(formData.영업자1수수료)
                                        : data.auth_cd === 5 ? Number(formData.영업자2수수료)
                                            : Number(formData.영업자3수수료),
                        "name": data.agent_name
                    })
                }
            }

            // 은행명으로 은행 코드 찾기
            const selectedBank = bank.find(b => b.name === formData.정산은행);
            const bankCode = selectedBank ? selectedBank.code : (clickData?.bank_cd || '');
            const sensitiveValue = (formValue, originalValue) => (
                canRevealMerchantSensitive && !sensitiveRevealed ? (originalValue ?? formValue) : formValue
            );

            await axios.post(process.env.REACT_APP_API + "/api/merchant/update", {
                id: clickData.id,
                mid: formData.가맹점ID,
                boss_nm: formData.대표자명,
                block_card: formData.불가카드.join(','),
                month_limit: formData.월한도,
                card_inst: formData.할부제한,
                card_part_cancel_yn: formData.부분취소사용여부,
                card_cancel_yn: formData.단말기취소사용여부,
                etc: formData.비고,
                card_fee: "",
                co_addr: formData.사업장주소,
                vat_disp_yn: formData.부가세표시,
                use_yn: formData.사용여부,
                card_use_yn: formData.사용여부 || '사용',
                bank_nm: formData.정산은행,
                co_no: formData.사업자등록번호,
                co_nm: formData.상호명,
                fee_vat_yn: formData.수수료등록기준,
                noti_pay_type: formData.결제공지,
                cat_fee: "",
                cat_cancel_yn: formData.수기취소사용여부,
                cancel_yn: formData.취소기능,
                day_limit: formData.일한도,
                accnt_nm: sensitiveValue(formData.예금주, clickData?.accnt_nm),
                bank_cd: bankCode,
                tax_email: sensitiveValue(formData.세금계산서Email, clickData?.tax_email),
                co_hp: sensitiveValue(formData.연락처, clickData?.co_hp),
                fee_up_yn: "",
                accnt_no: sensitiveValue(formData.계좌번호, clickData?.accnt_no),
                agent_id: (clickAgentData && clickAgentData.length > 0)
                    ? clickAgentData[clickAgentData.length - 1].agent_id
                    : "",
                deposit_yn: formData.바우처사용,
                withdrawal_fee: formData.출금수수료상속 ? null : Number(formData.출금수수료),
                semi_realtime_yn: formData.정산형태,

                up_data: agentArr,
                sugi_expose: formData.수기노출,
                payout_memo: formData.입금적요,
                force_realtime: formData.즉시적용,
                terminal_fee_yn: formData.단말기비부과,
                payout_hold_yn: formData.익일정산생략,
            }, {
                withCredentials: true,
            }).then(async (response) => {
                let tmp = response?.data;
                console.log(tmp)
                if (tmp?.code < 2000) {
                    let terminalFeeMessage = "";
                    try {
                        terminalFeeMessage = await saveFastTerminalFeeExemption(formData.가맹점ID, formData, originalFormData);
                    } catch (error) {
                        terminalFeeMessage = error.message;
                    }
                    setMessage({ msg: terminalFeeMessage ? `가맹점 수정에 성공했습니다. ${terminalFeeMessage}` : "가맹점 수정에 성공했습니다." });
                    setReload(e => !e);
                } else {
                    setMessage({ msg: tmp?.msg ?? "가맹점 수정에 실패했습니다." });
                }
            }).catch(error => {
                console.error(error);
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const onTerminate = async () => {
        if (isTerminating) return;
        if (!clickData?.mid) return;
        if (!window.confirm(`가맹점 ${clickData.mid} 을(를) 해지하시겠습니까?`)) return;
        const reason = window.prompt("해지 사유 (선택)") ?? "";

        setIsTerminating(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/merchant/terminate",
                { mid: clickData.mid, reason: reason || undefined },
                { withCredentials: true }
            );
            const tmp = response?.data;
            setMessage({ msg: tmp?.msg || (tmp?.code === 1000 ? "가맹점이 해지되었습니다." : "해지에 실패했습니다.") });
            if (tmp?.code === 1000) setReload(e => !e);
        } catch (error) {
            console.error(error);
            setMessage({ msg: "해지 처리 중 오류가 발생했습니다." });
        } finally {
            setIsTerminating(false);
        }
    };

    const onRestore = async () => {
        if (isTerminating) return;
        if (!clickData?.mid) return;
        if (!window.confirm(`가맹점 ${clickData.mid} 의 해지를 복구하시겠습니까?`)) return;

        setIsTerminating(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/merchant/restore",
                { mid: clickData.mid },
                { withCredentials: true }
            );
            const tmp = response?.data;
            setMessage({ msg: tmp?.msg || (tmp?.code === 1000 ? "가맹점 해지가 복구되었습니다." : "복구에 실패했습니다.") });
            if (tmp?.code === 1000) setReload(e => !e);
        } catch (error) {
            console.error(error);
            setMessage({ msg: "복구 처리 중 오류가 발생했습니다." });
        } finally {
            setIsTerminating(false);
        }
    };

    // ▼ "취소" 버튼
    const handleCancel = () => {
        // 1) agent 데이터 다시 초기 호출
        agentUpdateList(clickAgent, "Y");
        // 2) formData를 originalFormData로 되돌림
        setFormData(originalFormData);
        // 3) clickAgent, clickAgentData를 원래 값으로
        setClickAgent(getLowestAgentCode(clickData));
        setClickAgentData(originalClickAgentData);
    };

    const isDisabled = MyData?.role !== "SUPER";

    // 예금주 조회
    const { verifying: verifyingHolder, isVerified: holderVerified, verify: verifyHolder } =
        useAccountHolderVerify({ formData, setFormData, setMessage });


    return (
        <div style={{ padding: "5px" }}>
            {isTerminated && (
                <div style={{
                    margin: "0 0 8px",
                    padding: "8px 12px",
                    backgroundColor: "#fdecea",
                    border: "1px solid #f5c2c7",
                    borderRadius: "4px",
                    color: "#842029",
                    fontSize: "12px",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap"
                }}>
                    <span style={{
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: "3px",
                        fontSize: "11px"
                    }}>해지됨</span>
                    <span>해지일시: {clickData?.terminated_at}</span>
                    {clickData?.terminated_by && <span>· 처리자: {clickData.terminated_by}</span>}
                    {clickData?.terminated_reason && <span>· 사유: {clickData.terminated_reason}</span>}
                </div>
            )}
            {/* <div id="submerchants-modal" class="modal show_modal" tabindex="-1"> */}
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div style={{ padding: '0 0 0.5rem', overflowY: "auto", fontSize: "12px", display: 'flex', gap: "20px" }}>
                        <div className="list-info-box" style={{ width: "100%" }}>
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>등록일</span>
                                                <input
                                                    name='등록일'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.등록일}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>수정일</span>
                                                <input
                                                    name='수정일'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.수정일}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>사업자등록번호</span>
                                                <input
                                                    name='사업자등록번호'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.사업자등록번호}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>가맹점ID</span>
                                                <input
                                                    name='가맹점ID'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.가맹점ID}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>상호명</span>
                                                <input
                                                    name='상호명'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.상호명}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>대표자명</span>
                                                <input
                                                    name='대표자명'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.대표자명}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>연락처</span>
                                                <input
                                                    name='연락처'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.연락처}
                                                    onChange={handleChange}
                                                    disabled={isDisabled || (canRevealMerchantSensitive && !sensitiveRevealed)}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>사업장주소</span>
                                                <input
                                                    name='사업장주소'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.사업장주소}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            {/* <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    빠른즉결사용
                                                </span>
                                                <select
                                                    id="정산형태"
                                                    name="정산형태"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.정산형태}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                >
                                                    <option value="Y">Y</option>
                                                    <option value="N">N</option>
                                                </select>
                                            </div> */}
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "110px", height: "34px" }}
                                                >
                                                    지갑 사용
                                                </span>
                                                <select
                                                    id="바우처사용"
                                                    name="바우처사용"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.바우처사용}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                >
                                                    <option value="Y">Y</option>
                                                    <option value="N">N</option>
                                                </select>
                                            </div>
                                        </li>

                                        {formData.바우처사용 === "Y" && (
                                        <li>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    data-tooltip-id="withdrawal-fee-tooltip-update"
                                                    data-tooltip-html="체크 시: 상위(에이전트/시스템) 설정값을 그대로 적용합니다.<br/>체크 해제 시: 직접 입력한 금액이 적용됩니다.<br/>0 입력 시 출금 수수료 무료."
                                                    style={{ width: "110px", height: "34px", cursor: "help" }}
                                                >
                                                    출금 수수료
                                                    <Tooltip id="withdrawal-fee-tooltip-update" place="top" style={{ fontSize: "12px", maxWidth: "220px", lineHeight: "1.8", zIndex: 100000 }} />
                                                </span>
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "calc(100% - 112px)", paddingLeft: "6px" }}>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "0.7rem", whiteSpace: "nowrap", cursor: "pointer" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={formData.출금수수료상속}
                                                            onChange={(e) => setFormData(prev => ({
                                                                ...prev,
                                                                출금수수료상속: e.target.checked,
                                                                출금수수료: e.target.checked ? '' : prev.출금수수료,
                                                            }))}
                                                        />
                                                        상위 상속
                                                    </label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className="right-text"
                                                        style={{ flex: 1, border: "none", outline: "none", fontSize: "0.7rem", color: "#646464", backgroundColor: formData.출금수수료상속 ? "#f5f5f5" : "" }}
                                                        disabled={formData.출금수수료상속 || isDisabled}
                                                        value={formData.출금수수료상속 ? '' : formData.출금수수료}
                                                        placeholder={formData.출금수수료상속 ? (formData.출금수수료적용값 != null ? `상위 상속 중 (적용값: ${formData.출금수수료적용값}원)` : "상위 상속 중") : "0"}
                                                        onChange={(e) => setFormData(prev => ({ ...prev, 출금수수료: e.target.value }))}
                                                    />
                                                </div>
                                            </div>
                                        </li>
                                        )}

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>영업자</span>
                                                <select
                                                    id="영업자"
                                                    name="영업자"
                                                    className="form-select"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                    value={formData.영업자}
                                                    onChange={(e) => {
                                                        const selectedOption = levelData.find((a) => {
                                                            const agentType =
                                                                a.auth_cd === 1
                                                                    ? "지사"
                                                                    : a.auth_cd === 2
                                                                        ? "총판"
                                                                        : a.auth_cd === 3
                                                                            ? "대리점"
                                                                            : a.auth_cd === 4
                                                                                ? "영업자1"
                                                                                : a.auth_cd === 5
                                                                                    ? "영업자2"
                                                                                    : "영업자3"
                                                            const optionLabel = `(${agentType}) ${a.nm}`;
                                                            return optionLabel === e.target.value;
                                                        });
                                                        handleChange(e);
                                                        if (selectedOption) {
                                                            handleChangeAgent(selectedOption.code);
                                                        }
                                                    }}
                                                    disabled={isDisabled}
                                                >
                                                    {levelData.map((a, i) => {
                                                        const agentType =
                                                            a.auth_cd === 1
                                                                ? "지사"
                                                                : a.auth_cd === 2
                                                                    ? "총판"
                                                                    : a.auth_cd === 3
                                                                        ? "대리점"
                                                                        : a.auth_cd === 4
                                                                            ? "영업자1"
                                                                            : a.auth_cd === 5
                                                                                ? "영업자2"
                                                                                : "영업자3"
                                                        const optionLabel = `(${agentType}) ${a.nm}`;
                                                        return (
                                                            <option key={i} value={optionLabel}>
                                                                {optionLabel}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>수기노출</span>
                                                <select
                                                    id="수기노출"
                                                    name="수기노출"
                                                    className="form-select"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                    value={formData.수기노출}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                >
                                                    <option value="Y">Y</option>
                                                    <option value="N">N</option>
                                                </select>
                                            </div>
                                        </li>
                                        {
                                            level <= 1
                                                ?
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>지사</span>
                                                        <input
                                                            name='지사'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.지사}
                                                            onChange={handleChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>지사수수료</span>
                                                        <input
                                                            name='지사수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.지사수수료}
                                                            onChange={handleChange}
                                                            disabled={isDisabled}
                                                        />
                                                    </div>
                                                </li>
                                                :
                                                ""
                                        }
                                        {
                                            level <= 2
                                                ?
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>총판</span>
                                                        <input
                                                            name='총판'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.총판}
                                                            onChange={handleChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>총판수수료</span>
                                                        <input
                                                            name='총판수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.총판수수료}
                                                            onChange={handleChange}
                                                            disabled={isDisabled}
                                                        />
                                                    </div>
                                                </li>
                                                :
                                                ""
                                        }
                                        {
                                            level <= 3
                                                ?
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>대리점</span>
                                                        <input
                                                            name='대리점'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.대리점}
                                                            onChange={handleChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>대리점수수료</span>
                                                        <input
                                                            name='대리점수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.대리점수수료}
                                                            onChange={handleChange}
                                                            disabled={isDisabled}
                                                        />
                                                    </div>
                                                </li>
                                                :
                                                ""
                                        }
                                        {
                                            level <= 4
                                                ?
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>영업자1</span>
                                                        <input
                                                            name='영업자1'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.영업자1}
                                                            onChange={handleChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>영업자1수수료</span>
                                                        <input
                                                            name='영업자1수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.영업자1수수료}
                                                            onChange={handleChange}
                                                            disabled={isDisabled}
                                                        />
                                                    </div>
                                                </li>
                                                :
                                                ""
                                        }
                                        {
                                            level <= 5
                                                ?
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>영업자2</span>
                                                        <input
                                                            name='영업자2'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.영업자2}
                                                            onChange={handleChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>영업자2수수료</span>
                                                        <input
                                                            name='영업자2수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.영업자2수수료}
                                                            onChange={handleChange}
                                                            disabled={isDisabled}
                                                        />
                                                    </div>
                                                </li>
                                                :
                                                ""
                                        }
                                        {
                                            level <= 6
                                                ?
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>영업자3</span>
                                                        <input
                                                            name='영업자3'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.영업자3}
                                                            onChange={handleChange}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "110px", height: "34px" }}>영업자3수수료</span>
                                                        <input
                                                            name='영업자3수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                            value={formData.영업자3수수료}
                                                            onChange={handleChange}
                                                            disabled={isDisabled}
                                                        />
                                                    </div>
                                                </li>
                                                :
                                                ""
                                        }

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>가맹점수수료</span>
                                                <input
                                                    name='가맹점수수료'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.가맹점수수료}
                                                    onChange={handleChange}
                                                    disabled={true}
                                                    readOnly
                                                />
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>정산은행</span>
                                                <select
                                                    id="정산은행"
                                                    name="정산은행"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464"
                                                    }}
                                                    value={formData.정산은행}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                >
                                                    {
                                                        !bank.find(e => e.name === formData.정산은행) && (
                                                            <option value={formData.정산은행}>{formData.정산은행}</option>
                                                        )
                                                    }
                                                    {
                                                        bank.map((a, i) => (
                                                            <option key={i} value={a.name}>
                                                                {a.name}
                                                            </option>
                                                        ))
                                                    }
                                                </select>

                                            </div>
                                        </li>

                                        {/* 예약된 수수료 변경 건 표시 */}
                                        {clickData?.pending_reservation && (
                                            <li className='mobile'>
                                                <div style={{
                                                    width: "100%",
                                                    padding: "8px 12px",
                                                    backgroundColor: "#fff3cd",
                                                    border: "1px solid #ffeaa7",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#856404",
                                                    marginBottom: "5px"
                                                }}>
                                                    <div style={{ fontWeight: "bold", marginBottom: "3px" }}>
                                                        ⚠️ 예약된 수수료 변경 건 - {clickData.pending_reservation.apply_dt} 적용 예정
                                                    </div>
                                                    <div style={{ fontSize: "11px" }}>
                                                        {clickData.pending_reservation.fee_data?.map((fee, index) => (
                                                            <span key={index}>
                                                                {fee.name}: {fee.fee}%{index < clickData.pending_reservation.fee_data.length - 1 ? ' | ' : ''}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            </li>
                                        )}
                                        {!isDisabled && (
                                            <li className='mobile'>
                                                <div className="inner">
                                                    <span className="left-text" style={{ width: "110px", height: "34px", display: "flex", alignItems: "center", gap: "4px" }}>
                                                        즉시 적용
                                                        <span
                                                            data-tooltip-id="tooltip-force-realtime-update"
                                                            data-tooltip-content="수수료 관련 항목(지사/총판/대리점/영업자 수수료)에만 해당합니다. 그 외 항목은 저장 즉시 반영됩니다."
                                                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                                                        >
                                                            <Info size={13} style={{ color: "#888" }} />
                                                        </span>
                                                    </span>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", padding: "0 8px", height: "34px", fontSize: "12px", cursor: "pointer" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={formData.즉시적용}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, 즉시적용: e.target.checked }))}
                                                            style={{ width: "14px", height: "14px", cursor: "pointer" }}
                                                        />
                                                        자정 예약 없이 즉시 반영
                                                    </label>
                                                    <Tooltip id="tooltip-force-realtime-update" place="top" effect="solid" style={{ maxWidth: "260px", fontSize: "11px" }} />
                                                </div>
                                            </li>
                                        )}

                                        {canManageMerchantTerminalFee(MyData) && isTerminalFeeSettingBrand() && (
                                        <li className='mobile'>
                                            <div className="inner" style={{ alignItems: "flex-start", minHeight: isTerminalFeeEnabledFromOff(formData, originalFormData) ? "154px" : "34px" }}>
                                                <span className="left-text" style={{ width: "110px", height: "34px", display: "flex", alignItems: "center" }}>
                                                    단말기비 부과
                                                </span>
                                                <div style={{ width: "calc(100% - 112px)", padding: "0 8px" }}>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", height: "34px", fontSize: "12px", cursor: MyData?.role === "SUPER" ? "pointer" : "default" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={formData.단말기비부과 === "Y"}
                                                            onChange={(e) => setFormData(prev => ({
                                                                ...prev,
                                                                단말기비부과: e.target.checked ? "Y" : "N",
                                                                단말기비부과시점: e.target.checked ? (prev.단말기비부과시점 || DEFAULT_TERMINAL_FEE_APPLY_TYPE) : DEFAULT_TERMINAL_FEE_APPLY_TYPE,
                                                            }))}
                                                            disabled={MyData?.role !== "SUPER"}
                                                            style={{ width: "14px", height: "14px", cursor: MyData?.role === "SUPER" ? "pointer" : "default" }}
                                                        />
                                                        {formData.단말기비부과 === "Y"
                                                            ? "정산금에서 차감"
                                                            : <span style={{ color: "#dc3545", fontWeight: "600" }}>미부과</span>
                                                        }
                                                    </label>
                                                    {isTerminalFeeEnabledFromOff(formData, originalFormData) && (
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "5px", padding: "2px 0 8px", fontSize: "12px" }}>
                                                            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: MyData?.role === "SUPER" ? "pointer" : "default" }}>
                                                                <input
                                                                    type="radio"
                                                                    name="update_terminal_fee_apply_type"
                                                                    checked={formData.단말기비부과시점 === CURRENT_TERMINAL_FEE_APPLY_TYPE}
                                                                    onChange={() => setFormData(prev => ({ ...prev, 단말기비부과시점: CURRENT_TERMINAL_FEE_APPLY_TYPE }))}
                                                                    disabled={MyData?.role !== "SUPER"}
                                                                />
                                                                이번달부터 부과
                                                            </label>
                                                            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: MyData?.role === "SUPER" ? "pointer" : "default" }}>
                                                                <input
                                                                    type="radio"
                                                                    name="update_terminal_fee_apply_type"
                                                                    checked={formData.단말기비부과시점 !== CURRENT_TERMINAL_FEE_APPLY_TYPE}
                                                                    onChange={() => setFormData(prev => ({ ...prev, 단말기비부과시점: DEFAULT_TERMINAL_FEE_APPLY_TYPE }))}
                                                                    disabled={MyData?.role !== "SUPER"}
                                                                />
                                                                다음달부터 부과
                                                            </label>
                                                            <TerminalFeePolicyGuide formData={formData} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                        )}

                                        {getBrand().key !== "fast" && (
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px", display: "flex", alignItems: "center" }}>
                                                    익일정산 생략
                                                </span>
                                                <label style={{ display: "flex", alignItems: "center", gap: "8px", padding: "0 8px", height: "34px", fontSize: "12px", cursor: MyData?.role === "SUPER" ? "pointer" : "default" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={formData.익일정산생략 === "Y"}
                                                        onChange={(e) => setFormData(prev => ({ ...prev, 익일정산생략: e.target.checked ? "Y" : "N" }))}
                                                        disabled={MyData?.role !== "SUPER"}
                                                        style={{ width: "14px", height: "14px", cursor: MyData?.role === "SUPER" ? "pointer" : "default" }}
                                                    />
                                                    {formData.익일정산생략 === "Y"
                                                        ? <span style={{ color: "#dc3545", fontWeight: "600" }}>생략</span>
                                                        : "정상"
                                                    }
                                                </label>
                                            </div>
                                        </li>
                                        )}

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>계좌번호</span>
                                                <input
                                                    name='계좌번호'
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: (isDisabled || (canRevealMerchantSensitive && !sensitiveRevealed)) ? "calc(100% - 112px)" : "calc(100% - 112px - 76px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.계좌번호}
                                                    onChange={handleChange}
                                                    disabled={isDisabled || (canRevealMerchantSensitive && !sensitiveRevealed)}
                                                />
                                                {!isDisabled && !(canRevealMerchantSensitive && !sensitiveRevealed) && (
                                                    <button
                                                        type="button"
                                                        onClick={verifyHolder}
                                                        disabled={verifyingHolder}
                                                        style={verifyBtnStyle(verifyingHolder)}
                                                    >
                                                        {verifyingHolder ? "조회중" : "계좌 확인"}
                                                    </button>
                                                )}
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>예금주</span>
                                                <input
                                                    name='예금주'
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: holderVerified ? "calc(100% - 112px - 60px)" : "calc(100% - 112px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.예금주}
                                                    onChange={handleChange}
                                                    disabled={isDisabled || (canRevealMerchantSensitive && !sensitiveRevealed)}
                                                />
                                                {holderVerified && (
                                                    <span style={verifiedBadgeStyle}>확인됨</span>
                                                )}
                                            </div>
                                        </li>

                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "110px", height: "34px" }}>입금적요</span>
                                                <input
                                                    name="입금적요"
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 112px)", border: "none", outline: "none" }}
                                                    value={formData.입금적요}
                                                    onChange={handleChange}
                                                    disabled={isDisabled}
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="modal-footer" style={{ minHeight: "61px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                            <RevealSensitiveButton
                                enabled={canRevealMerchantSensitive}
                                loading={sensitiveLoading}
                                revealed={sensitiveRevealed}
                                onClick={revealSensitive}
                            />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                        {
                            MyData?.role == "SUPER"
                                ?
	                                <>
                                    {canRevealMerchantSensitive && !sensitiveRevealed && (
                                        <span style={{
                                            color: "#92400e",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                        }}>
                                            수정하려면 먼저 원문 조회가 필요합니다.
                                        </span>
                                    )}
	                                    <button
                                        type="submit"
                                        className="btn btn-primary w-20 reg_btn"
                                        onClick={() => onSubmit()}
                                        disabled={isSubmitting || (canRevealMerchantSensitive && !sensitiveRevealed)}
                                        title={canRevealMerchantSensitive && !sensitiveRevealed ? "민감정보 원문 조회 후 수정할 수 있습니다." : ""}
                                    >
                                        수정
                                    </button>
                                    <input
                                        type="button"
                                        className="btn btn-primary w-20 close_btn"
                                        onClick={() => handleCancel()}
                                        style={{ backgroundColor: 'darkred', border: 'none' }}
                                        value="취소"
                                    />
                                    {isTerminated ? (
                                        <button
                                            type="button"
                                            className="btn"
                                            onClick={() => onRestore()}
                                            disabled={isTerminating}
                                            style={{
                                                padding: '0 16px',
                                                height: '38px',
                                                backgroundColor: 'transparent',
                                                color: '#198754',
                                                border: '1px solid #198754',
                                                borderRadius: '4px',
                                                fontWeight: 600,
                                                whiteSpace: 'nowrap',
                                                cursor: isTerminating ? 'not-allowed' : 'pointer',
                                            }}
                                        >
                                            해지 복구
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn"
                                            onClick={() => onTerminate()}
                                            disabled={isTerminating}
                                            style={{
                                                padding: '0 16px',
                                                height: '38px',
                                                backgroundColor: 'transparent',
                                                color: '#b02a37',
                                                border: '1px solid #b02a37',
                                                borderRadius: '4px',
                                                fontWeight: 600,
                                                whiteSpace: 'nowrap',
                                                cursor: isTerminating ? 'not-allowed' : 'pointer',
                                            }}
                                        >
                                            가맹점 해지
                                        </button>
                                    )}
                                </>
                                :
                                ""
                        }
                        </div>
                    </div>
                </div>
            </div>
            {/* </div > */}
        </div >
    )
}


function ManualCardPolicySection({ mid, merchantName, merchant, canEdit, setMessage, setReload }) {
    const [issuers, setIssuers] = useState([]);
    const [policyMap, setPolicyMap] = useState({});
    const [originalPayload, setOriginalPayload] = useState("[]");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [sameCardPolicy, setSameCardPolicy] = useState({
        동일카드일일수기결제제한: "N",
        동일카드일일수기결제허용횟수: "1",
    });
    const [originalSameCardPayload, setOriginalSameCardPayload] = useState(JSON.stringify({
        manual_same_card_limit_yn: "N",
        manual_same_card_daily_limit: null,
    }));
    const [sameCardSaving, setSameCardSaving] = useState(false);

    const installmentOptions = [
        { value: "", label: "제한 없음" },
        ...Array.from({ length: 13 }, (_, i) => ({
            value: String(i),
            label: i === 0 ? "일시불만" : `${i}개월 이하`,
        })),
    ];

    const formatInstallment = (value) => {
        if (value === null || value === undefined || value === "") return "제한 없음";
        const num = Number(value);
        if (num === 0) return "일시불만";
        return `${num}개월 이하`;
    };

    const normalizePolicy = (policy) => ({
        issuer: policy.issuer,
        blocked_yn: policy.blocked_yn === "Y" ? "Y" : "N",
        max_installment: policy.blocked_yn === "Y"
            ? null
            : policy.max_installment === null || policy.max_installment === undefined || policy.max_installment === ""
                ? null
                : Number(policy.max_installment),
    });

    const normalizePayload = (map) => Object.values(map)
        .filter((policy) => policy?.enabled && policy?.issuer)
        .map(normalizePolicy)
        .sort((a, b) => a.issuer.localeCompare(b.issuer, "ko"));

    const payloadString = JSON.stringify(normalizePayload(policyMap));
    const hasChanges = payloadString !== originalPayload;
    const sameCardPayloadString = JSON.stringify(buildManualSameCardLimitPayload(sameCardPolicy));
    const hasSameCardChanges = sameCardPayloadString !== originalSameCardPayload;

    useEffect(() => {
        const nextPolicy = {
            동일카드일일수기결제제한: merchant?.manual_same_card_limit_yn === "Y" ? "Y" : "N",
            동일카드일일수기결제허용횟수: String(normalizeManualSameCardDailyLimit(merchant?.manual_same_card_daily_limit)),
        };
        setSameCardPolicy(nextPolicy);
        setOriginalSameCardPayload(JSON.stringify(buildManualSameCardLimitPayload(nextPolicy)));
    }, [merchant?.id, merchant?.manual_same_card_limit_yn, merchant?.manual_same_card_daily_limit]);

    const loadPolicy = async () => {
        if (!mid) return;
        setLoading(true);
        try {
            const [issuerResponse, policyResponse] = await Promise.all([
                axios.get(process.env.REACT_APP_API + "/api/card-info/issuers", { withCredentials: true }),
                axios.post(process.env.REACT_APP_API + "/api/merchant/manual-card-policy/list", { mid }, { withCredentials: true }),
            ]);

            const issuerTmp = issuerResponse?.data;
            const policyTmp = policyResponse?.data;

            if (issuerTmp?.code >= 2000) {
                setMessage({ msg: issuerTmp?.msg || "카드사 목록 조회에 실패했습니다." });
                setIssuers([]);
            } else {
                setIssuers(issuerTmp?.data ?? []);
            }

            if (policyTmp?.code >= 2000) {
                setMessage({ msg: policyTmp?.msg || "수기결제 카드 정책 조회에 실패했습니다." });
                setPolicyMap({});
                setOriginalPayload("[]");
                return;
            }

            const nextMap = {};
            (policyTmp?.data?.policies ?? []).forEach((policy) => {
                if (!policy?.issuer) return;
                nextMap[policy.issuer] = {
                    id: policy.id,
                    issuer: policy.issuer,
                    enabled: true,
                    blocked_yn: policy.blocked_yn === "Y" ? "Y" : "N",
                    max_installment: policy.blocked_yn === "Y" ? null : policy.max_installment,
                };
            });
            setPolicyMap(nextMap);
            setOriginalPayload(JSON.stringify(normalizePayload(nextMap)));
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || "수기결제 카드 정책을 불러오는 중 오류가 발생했습니다." });
            setIssuers([]);
            setPolicyMap({});
            setOriginalPayload("[]");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadPolicy();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mid]);

    const updatePolicy = (issuer, field, value) => {
        if (!canEdit) return;
        setPolicyMap((prev) => {
            const current = prev[issuer] || {
                issuer,
                enabled: false,
                blocked_yn: "N",
                max_installment: null,
            };

            if (field === "enabled") {
                const enabled = value === true;
                if (!enabled) {
                    return { ...prev, [issuer]: { ...current, enabled: false, blocked_yn: "N", max_installment: null } };
                }
                return { ...prev, [issuer]: { ...current, enabled: true } };
            }

            if (field === "blocked_yn") {
                return {
                    ...prev,
                    [issuer]: {
                        ...current,
                        enabled: true,
                        blocked_yn: value,
                        max_installment: value === "Y" ? null : current.max_installment,
                    },
                };
            }

            if (field === "max_installment") {
                return {
                    ...prev,
                    [issuer]: {
                        ...current,
                        enabled: true,
                        max_installment: value === "" ? null : Number(value),
                    },
                };
            }

            return { ...prev, [issuer]: { ...current, [field]: value } };
        });
    };

    const saveSameCardPolicy = async () => {
        if (!mid || !canEdit || sameCardSaving || !hasSameCardChanges) return;
        setSameCardSaving(true);
        try {
            const payload = buildManualSameCardLimitPayload(sameCardPolicy);
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/merchant/update",
                {
                    id: merchant?.id,
                    mid,
                    ...payload,
                },
                { withCredentials: true }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setOriginalSameCardPayload(JSON.stringify(payload));
                setMessage({ msg: tmp?.msg || "동일 카드 일일 수기결제 제한 저장 성공" });
                setReload?.((value) => !value);
            } else {
                setMessage({ msg: tmp?.msg || "동일 카드 일일 수기결제 제한 저장에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || "동일 카드 일일 수기결제 제한 저장 중 오류가 발생했습니다." });
        } finally {
            setSameCardSaving(false);
        }
    };

    const savePolicy = async () => {
        if (!mid || !canEdit || saving || !hasChanges) return;
        const payload = normalizePayload(policyMap);
        if (payload.length === 0 && originalPayload !== "[]") {
            if (!window.confirm("저장하면 이 가맹점의 카드 정책이 전체 허용 상태로 변경됩니다.")) return;
        }

        setSaving(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/merchant/manual-card-policy/save",
                { mid, policies: payload },
                { withCredentials: true }
            );
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: tmp?.msg || "수기결제 카드 정책 저장 성공" });
                await loadPolicy();
            } else {
                setMessage({ msg: tmp?.msg || "수기결제 카드 정책 저장에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: error?.response?.data?.msg || "수기결제 카드 정책 저장 중 오류가 발생했습니다." });
        } finally {
            setSaving(false);
        }
    };

    const sectionStyle = {
        margin: "0",
        padding: "14px",
        border: "1px solid #e5e7eb",
        borderRadius: "6px",
        backgroundColor: "#fff",
    };
    const controlStyle = {
        height: "34px",
        border: "1px solid #d1d5db",
        borderRadius: "4px",
        padding: "0 8px",
        fontSize: "12px",
        color: "#374151",
        backgroundColor: "#fff",
    };
    const rowStyle = {
        display: "grid",
        gridTemplateColumns: "minmax(180px, 1.3fr) 96px 100px 140px 160px",
        gap: "8px",
        alignItems: "center",
        minHeight: "46px",
        padding: "6px 0",
        borderTop: "1px solid #f1f5f9",
    };
    const sameCardLimitEnabled = sameCardPolicy.동일카드일일수기결제제한 === "Y";

    const badgeStyle = (enabled) => ({
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        height: "24px",
        padding: "0 8px",
        borderRadius: "999px",
        fontSize: "11px",
        fontWeight: "700",
        color: enabled ? "#1d4ed8" : "#047857",
        backgroundColor: enabled ? "#dbeafe" : "#ecfdf5",
        border: enabled ? "1px solid #bfdbfe" : "1px solid #a7f3d0",
        whiteSpace: "nowrap",
    });

    return (
        <div style={sectionStyle}>
            <div style={{ padding: "12px", border: "1px solid #e5e7eb", borderRadius: "6px", backgroundColor: "#f8fafc", marginBottom: "12px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                    <div>
                        <div style={{ fontSize: "13px", fontWeight: "700", color: "#111827" }}>동일 카드 일일 수기결제 제한</div>
                        <div style={{ marginTop: "6px", padding: "6px 8px", fontSize: "12px", color: "#b91c1c", lineHeight: 1.45, fontWeight: "700", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "4px" }}>
                            동일 카드 제한은 당일 승인된 수기결제 횟수를 기준으로 적용됩니다. 결제를 취소하더라도 횟수가 다시 돌아오지 않습니다.
                        </div>
                    </div>
                    {canEdit && (
                        <button
                            type="button"
                            className="btn btn-primary reg_btn"
                            onClick={saveSameCardPolicy}
                            disabled={sameCardSaving || !hasSameCardChanges}
                            style={{ height: "30px", fontSize: "12px", padding: "0 12px", opacity: sameCardSaving || !hasSameCardChanges ? 0.55 : 1 }}
                        >
                            {sameCardSaving ? "저장중" : "제한 저장"}
                        </button>
                    )}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap", marginTop: "10px" }}>
                    <button
                        type="button"
                        onClick={() => {
                            if (!canEdit) return;
                            setSameCardPolicy(prev => ({
                                ...prev,
                                동일카드일일수기결제제한: sameCardLimitEnabled ? "N" : "Y",
                                동일카드일일수기결제허용횟수: String(normalizeManualSameCardDailyLimit(prev.동일카드일일수기결제허용횟수)),
                            }));
                        }}
                        disabled={!canEdit}
                        aria-pressed={sameCardLimitEnabled}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            height: "30px",
                            padding: "0 10px 0 6px",
                            border: sameCardLimitEnabled ? "1px solid #2563eb" : "1px solid #cbd5e1",
                            borderRadius: "999px",
                            backgroundColor: sameCardLimitEnabled ? "#eff6ff" : "#f8fafc",
                            color: sameCardLimitEnabled ? "#1d4ed8" : "#475569",
                            fontSize: "12px",
                            fontWeight: "700",
                            cursor: canEdit ? "pointer" : "default",
                            opacity: canEdit ? 1 : 0.65,
                        }}
                    >
                        <span
                            aria-hidden="true"
                            style={{
                                position: "relative",
                                width: "38px",
                                height: "20px",
                                borderRadius: "999px",
                                backgroundColor: sameCardLimitEnabled ? "#2563eb" : "#cbd5e1",
                                transition: "background-color 0.15s ease",
                                flex: "none",
                            }}
                        >
                            <span
                                style={{
                                    position: "absolute",
                                    top: "3px",
                                    left: sameCardLimitEnabled ? "21px" : "3px",
                                    width: "14px",
                                    height: "14px",
                                    borderRadius: "50%",
                                    backgroundColor: "#ffffff",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.18)",
                                    transition: "left 0.15s ease",
                                }}
                            />
                        </span>
                        {sameCardLimitEnabled ? "제한 사용" : "제한 없음"}
                    </button>
                    {sameCardLimitEnabled && (
                        <label style={{ display: "flex", alignItems: "center", gap: "8px", height: "30px", fontSize: "12px" }}>
                            <span style={{ color: "#475569", whiteSpace: "nowrap" }}>일일 허용 횟수</span>
                            <select
                                name="동일카드일일수기결제허용횟수"
                                style={{ ...controlStyle, width: "86px", height: "30px" }}
                                value={String(normalizeManualSameCardDailyLimit(sameCardPolicy.동일카드일일수기결제허용횟수))}
                                onChange={(e) => setSameCardPolicy(prev => ({ ...prev, 동일카드일일수기결제허용횟수: e.target.value }))}
                                disabled={!canEdit}
                            >
                                {MANUAL_SAME_CARD_DAILY_LIMIT_OPTIONS.map((limit) => (
                                    <option key={limit} value={limit}>{limit}회</option>
                                ))}
                            </select>
                        </label>
                    )}
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap", marginBottom: "10px" }}>
                <div>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: "#111827" }}>수기결제 카드 정책</div>
                    <div style={{ marginTop: "3px", fontSize: "12px", color: "#6b7280" }}>
                        {merchantName ? `${merchantName} (${mid})` : mid} · issuer 기준 · 개별 설정 OFF는 전체 허용 기본값입니다.
                    </div>
                </div>
                {canEdit && (
                    <button
                        type="button"
                        className="btn btn-primary reg_btn"
                        onClick={savePolicy}
                        disabled={loading || saving || !hasChanges}
                        style={{ height: "32px", fontSize: "12px", padding: "0 14px", opacity: loading || saving || !hasChanges ? 0.55 : 1 }}
                    >
                        {saving ? "저장중" : "정책 저장"}
                    </button>
                )}
            </div>

            {loading ? (
                <div style={{ padding: "18px", textAlign: "center", color: "#6b7280", fontSize: "12px", backgroundColor: "#f8fafc", borderRadius: "4px" }}>
                    카드 정책을 불러오는 중입니다.
                </div>
            ) : issuers.length === 0 ? (
                <div style={{ padding: "18px", textAlign: "center", color: "#92400e", fontSize: "12px", backgroundColor: "#fffbeb", border: "1px solid #fde68a", borderRadius: "4px", fontWeight: "600" }}>
                    표시할 카드사 목록이 없습니다.
                </div>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <div style={{ minWidth: "660px" }}>
                        <div style={{ ...rowStyle, borderTop: "none", padding: "0 0 6px", color: "#6b7280", fontSize: "11px", fontWeight: "700" }}>
                            <div>카드사명</div>
                            <div>정책 적용</div>
                            <div>사용 여부</div>
                            <div>최대 할부</div>
                            <div>상태</div>
                        </div>
                        {issuers.map((issuerInfo) => {
                            const issuer = issuerInfo.issuer;
                            const policy = policyMap[issuer] || { issuer, enabled: false, blocked_yn: "N", max_installment: null };
                            const enabled = !!policy.enabled;
                            const blocked = enabled && policy.blocked_yn === "Y";
                            return (
                                <div key={issuer} style={rowStyle}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0 }}>
                                        <span style={{ fontSize: "12px", color: "#111827", fontWeight: "700", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{issuer}</span>
                                        <span style={{ flex: "none", fontSize: "11px", color: "#9ca3af" }}>BIN {issuerInfo.bin_count}</span>
                                    </div>
                                    <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", color: "#374151", cursor: canEdit ? "pointer" : "default" }}>
                                        <input
                                            type="checkbox"
                                            checked={enabled}
                                            disabled={!canEdit}
                                            onChange={(e) => updatePolicy(issuer, "enabled", e.target.checked)}
                                            style={{ width: "14px", height: "14px" }}
                                        />
                                        개별 설정
                                    </label>
                                    <select
                                        value={blocked ? "Y" : "N"}
                                        onChange={(e) => updatePolicy(issuer, "blocked_yn", e.target.value)}
                                        disabled={!canEdit || !enabled}
                                        style={{ ...controlStyle, width: "100%", backgroundColor: enabled ? "#fff" : "#f9fafb", color: enabled ? "#374151" : "#9ca3af" }}
                                    >
                                        <option value="N">허용</option>
                                        <option value="Y">차단</option>
                                    </select>
                                    <select
                                        value={policy.max_installment === null || policy.max_installment === undefined ? "" : String(policy.max_installment)}
                                        onChange={(e) => updatePolicy(issuer, "max_installment", e.target.value)}
                                        disabled={!canEdit || !enabled || blocked}
                                        style={{
                                            ...controlStyle,
                                            width: "100%",
                                            backgroundColor: !enabled || blocked ? "#f3f4f6" : "#fff",
                                            color: !enabled || blocked ? "#9ca3af" : "#374151",
                                        }}
                                    >
                                        {installmentOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0 }}>
                                        <span style={badgeStyle(enabled)}>{enabled ? "개별 설정" : "기본값"}</span>
                                        <span style={{ fontSize: "11px", color: blocked ? "#b91c1c" : "#6b7280", fontWeight: blocked ? "600" : "400", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                            {blocked ? "차단" : `허용 · ${formatInstallment(policy.max_installment)}`}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {!canEdit && (
                <div style={{ marginTop: "8px", fontSize: "11px", color: "#92400e" }}>
                    정책 수정 권한이 없습니다.
                </div>
            )}
        </div>
    );
}

function PaymentInfo({ setMessage, clickData, setReload }) {
    const [listData, setListData] = useState([]);
    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(5);
    const [combineData, setCombineData] = useState([]);

    // ▼ 기존 formData 초깃값을 객체로 정의
    const buildInitialFormData = (cd) => {
        // 필요 시 cd 검사
        return {
            정산주기: "D0",
            적용일자: "",
            즉시여부: "N",
            정산지연분: "",
        };
    };

    // ▼ "기본값"을 저장해둔다.
    const [originalFormData, setOriginalFormData] = useState(buildInitialFormData(clickData));

    // ▼ 실제 formData 상태
    const [formData, setFormData] = useState(buildInitialFormData(clickData));

    // ▼ clickData가 변경될 때마다 formData / originalFormData 갱신
    useEffect(() => {
        // 새로 초기값 생성
        const newInitial = buildInitialFormData(clickData);
        setFormData(newInitial);
        setOriginalFormData(newInitial);
    }, [clickData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setFormData((prevFormData) => {
                const updatedCheckboxes = checked
                    ? [...prevFormData[name], value]
                    : prevFormData[name].filter((item) => item !== value);

                return { ...prevFormData, [name]: updatedCheckboxes };
            });
        } else {
            setFormData((prev) => {
                const next = { ...prev, [name]: value };
                if (name === "즉시여부" && value === "N") {
                    next.정산지연분 = "";
                }
                if (name === "정산지연분" && value !== "") {
                    const num = parseInt(value, 10);
                    if (Number.isNaN(num)) {
                        next.정산지연분 = "";
                    } else if (num < 5) {
                        next.정산지연분 = "5";
                    } else if (num > 59) {
                        next.정산지연분 = "59";
                    } else {
                        next.정산지연분 = String(num);
                    }
                }
                return next;
            });
        }
    };

    // 기존 로직: 처음 마운트 시 LevelList
    useEffect(() => {
        LevelList()
    }, [clickData])

    const LevelList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/merchant/settlement-info`, {
            withCredentials: true,
            params: {
                mid: clickData.mid
            }
        }).then((response) => {
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp.data?.merchant);
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    };

    // ▼ 수정 중복 방지용
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        // 이미 실행 중이면 return
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const delayNum = formData?.정산지연분 ? parseInt(formData.정산지연분, 10) : NaN;
            const delayValid = formData?.즉시여부 !== "Y" || (Number.isInteger(delayNum) && delayNum >= 5 && delayNum <= 59);
            if (
                !clickData?.mid ||
                !formData?.정산주기 ||
                !formData?.즉시여부 ||
                !formData?.적용일자 ||
                (formData?.즉시여부 === "Y" && !delayValid)
            ) {
                setMessage({
                    msg: formData?.즉시여부 === "Y" && !delayValid
                        ? "정산지연분은 5~59분 사이의 정수로 입력해주세요."
                        : "모든 필수 값을 입력해주세요."
                });
                return;
            }

            await axios.post(process.env.REACT_APP_API + "/api/merchant/update/settlement", {
                mid: clickData.mid,
                settlement_cycle: formData.정산주기,
                realtime_delay_tm: formData.정산지연분,
                realtime_st_yn: formData.즉시여부,
                fr_dt: formData.적용일자,
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setMessage({ msg: "수정에 성공했습니다." })
                    setReload(e => !e)
                }
                else {
                    setMessage({ msg: "수정에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        } finally {
            // API 끝나면 다시 false
            setIsSubmitting(false);
        }
    }

    const tableHeaderData = [
        { "no": 1, "text": "시작일자", "width": "80px", "textAlign": "center" },
        { "no": 2, "text": "종료일자", "width": "80px", "textAlign": "center" },
        { "no": 3, "text": "정산주기", "width": "80px", "textAlign": "center" },
        { "no": 4, "text": "즉시여부", "width": "80px", "textAlign": "center" },
        { "no": 5, "text": "정산지연분", "width": "80px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData?.slice((page - 1) * maxFirstPage, page * maxFirstPage) ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                tableBodyData.push([
                    { "no": 1, "text": data.fr_dt, "width": "80px", "textAlign": "center" },
                    { "no": 2, "text": data.to_dt, "width": "80px", "textAlign": "center" },
                    { "no": 3, "text": data.settlement_cycle, "width": "80px", "textAlign": "center" },
                    { "no": 4, "text": data.realtime_st_yn, "width": "80px", "textAlign": "center" },
                    { "no": 5, "text": data.realtime_delay_tm, "width": "80px", "textAlign": "center" },
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listData, page, maxFirstPage])

    // ▼ "취소" 버튼 로직: formData를 다시 originalFormData로 되돌린다
    const handleCancel = () => {
        setFormData(originalFormData);
        // 모달을 닫는 로직이 필요하다면 setModal(false) 등을 사용
        // (현재 PaymentInfo에서는 setModal이 존재하지 않으므로, 단순히 값만 되돌림)
    };

    return (
        <div style={{ padding: "5px" }}>
            {/* <div id="submerchants-modal" class="modal show_modal" tabindex="-1"> */}
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    <div style={{ padding: '0 0 0.5rem', overflowY: "auto", fontSize: "12px", display: 'flex', gap: "20px" }}>
                        <div className="list-info-box" style={{ width: "100%" }}>
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "120px", height: "34px" }}>정산주기</span>
                                                <select
                                                    id="정산주기"
                                                    name="정산주기"
                                                    className="form-select"
                                                    style={{ width: "calc(100% - 122px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                    value={formData.정산주기}
                                                    onChange={handleChange}
                                                >
                                                    <option value="D0">당일</option>
                                                    <option value="D1">D+1</option>
                                                    <option value="D2">D+2</option>
                                                    <option value="D3">D+3</option>
                                                    <option value="D4">D+4</option>
                                                    <option value="D5">D+5</option>
                                                    <option value="D6">D+6</option>
                                                    <option value="D7">D+7</option>
                                                    <option value="D8">D+8</option>
                                                    <option value="D9">D+9</option>
                                                    <option value="D10">D+10</option>
                                                </select>
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "120px", height: "34px" }}>적용일자</span>
                                                <input
                                                    name='적용일자'
                                                    type="text"
                                                    className="right-text"
                                                    style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                    value={formData.적용일자}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </li>
                                        <li className='mobile'>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "120px", height: "34px" }}>즉시여부</span>
                                                <select
                                                    id="즉시여부"
                                                    name="즉시여부"
                                                    className="form-select"
                                                    style={{ width: "calc(100% - 122px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                    value={formData.즉시여부}
                                                    onChange={handleChange}
                                                >
                                                    <option value="N">N</option>
                                                    <option value="Y">Y</option>
                                                </select>
                                            </div>
                                            <div className="inner">
                                                <span className="left-text" style={{ width: "120px", height: "34px" }}>정산지연분</span>
                                                <input
                                                    name="정산지연분"
                                                    type="number"
                                                    min={5}
                                                    max={59}
                                                    step={1}
                                                    placeholder="5~59"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        opacity: formData.즉시여부 === "Y" ? 1 : 0.6,
                                                        cursor: formData.즉시여부 === "Y" ? "text" : "not-allowed"
                                                    }}
                                                    value={formData.정산지연분}
                                                    onChange={handleChange}
                                                    disabled={formData.즉시여부 !== "Y"}
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData ?? []}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            // height={"400px"}
                            nonePage={false}
                        />
                    </div>

                    {/* 수정 중복 방지용 */}
                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={() => onSubmit()}
                            disabled={isSubmitting} // 버튼 비활성화
                        >
                            수정
                        </button>
                        {/* ▼ 닫기 -> 취소로 라벨 변경 + 기존 값으로 되돌림 */}
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={handleCancel}
                            style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }}
                            value="취소"
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

function PGInfo({ setMessage, clickData, setReload }) {
    let MyData = useSelector((state) => { return state.MyData })

    const [listData, setListData] = useState([])
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(5)
    const [combineData, setCombineData] = useState([])
    const [reservations, setReservations] = useState([])
    const [reservationData, setReservationData] = useState([])

    // ▼ 초기값을 만드는 함수
    const buildInitialFormData = (cd) => {
        // cd = clickData
        return {
            PG사: "",           // (예: "03" 처럼 기본 선택값을 넣어도 됨)
            결제수단: "",        // (예: "01" 처럼 기본값 설정 가능)
            적용일자: "",        // (예: "20230101" 등)
            PGMID: "",
            PGKEY: "",
            수수료: "",
            키인형태: "",
            상위수수료: "",
            상위정산주기: "D0",  // (예: "D0"로 기본값 설정)
            자체즉결: "N",       // 자체즉결 항목 추가 (기본값: 미사용)
            실제수수료: "",      // 실제 수수료 필드 추가
            즉시적용: false,
        };
    };

    // ▼ 초기값을 "originalFormData"에 저장
    const [originalFormData, setOriginalFormData] = useState(buildInitialFormData(clickData));

    // ▼ 실제 formData 상태
    const [formData, setFormData] = useState(buildInitialFormData(clickData));

    // ▼ clickData가 변경될 때마다 formData/originalFormData 갱신
    useEffect(() => {
        const newInitial = buildInitialFormData(clickData);
        setFormData(newInitial);
        setOriginalFormData(newInitial);
    }, [clickData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setFormData((prevFormData) => {
                const updatedCheckboxes = checked
                    ? [...prevFormData[name], value]
                    : prevFormData[name].filter((item) => item !== value);
                return { ...prevFormData, [name]: updatedCheckboxes };
            });
        } else if (name === '적용일자') {
            // 적용일자: 숫자만 입력 가능, 최대 8자리
            const numericValue = value.replace(/\D/g, '').slice(0, 8);
            setFormData({ ...formData, [name]: numericValue });
        } else if (name === 'PG사') {
            // PG사 변경 시, 해당 PG에서 지원하지 않는 결제수단이 선택되어 있으면 초기화
            const limited = value !== "04"; // 윈글로벌(04) 외에는 제한
            const needReset = limited && (formData.결제수단 === "08" || formData.결제수단 === "11");
            setFormData({ ...formData, [name]: value, ...(needReset ? { 결제수단: "" } : {}) });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // yyyymmdd 형식 검증 함수
    const isValidDateFormat = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return false;

        const year = parseInt(dateStr.slice(0, 4), 10);
        const month = parseInt(dateStr.slice(4, 6), 10);
        const day = parseInt(dateStr.slice(6, 8), 10);

        if (month < 1 || month > 12) return false;

        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) return false;

        return true;
    };

    // 기존: LevelList
    useEffect(() => {
        LevelList()
    }, [clickData])

    const LevelList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/merchant/pg-info`, {
            withCredentials: true,
            params: {
                mid: clickData.mid
            }
        }).then((response) => {
            let tmp = response?.data;

            if (tmp?.code < 2000) {
                setListData(tmp.data?.merchant);
                setReservations(tmp.data?.reservations || []);
            }
            else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    // ▼ "수정" 버튼 중복 방지용
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        // 이미 제출 중이면 return
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const body = {
                mid: clickData.mid,
                cat_id: formData.PGMID,
                fee: formData.수수료,
                fr_dt: formData.적용일자,
                org_fee: formData.상위수수료,
                org_settlement_cycle: formData.상위정산주기,
                pg_cd: formData.PG사,
                pg_key_in_ci: formData.키인형태,
                pg_license_key: formData.PGKEY,
                svc_prdt_cd: formData.결제수단,
                self_payment: formData.자체즉결,  // 자체즉결 필드 추가
            }

            // 자체즉결이 Y일 때만 실제수수료 추가
            if (formData.자체즉결 === "Y") {
                body.self_realtime_fee = formData.실제수수료;
            }

            body.force_realtime = formData.즉시적용;

            if (Object.values(body).some(value => value === undefined || value === null || value === "")) {
                setMessage({ msg: "모든 필수 값을 입력해주세요." });
                return;
            }

            // 적용일자 yyyymmdd 형식 검증
            if (!isValidDateFormat(formData.적용일자)) {
                setMessage({ msg: "적용일자를 올바른 형식(YYYYMMDD)으로 입력해주세요." });
                return;
            }

            await axios.post(process.env.REACT_APP_API + "/api/merchant/update/pg", body, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setMessage({ msg: "수정에 성공했습니다." })
                    setReload(e => !e)
                }
                else {
                    setMessage({ msg: "수정에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        } finally {
            // API 끝나면 다시 false
            setIsSubmitting(false);
        }
    }

    const tableHeaderData = MyData.role == "SUPER" ?
        [
            { "no": 1, "text": "PG사", "width": "100px", "textAlign": "center" },
            { "no": 2, "text": "결제수단", "width": "70px", "textAlign": "center" },
            { "no": 5, "text": "수수료", "width": "60px", "textAlign": "center" },
            { "no": 6, "text": "키인형태", "width": "70px", "textAlign": "center" },
            { "no": 7, "text": "상위수수료", "width": "80px", "textAlign": "center" },
            { "no": 8, "text": "상위정산주기", "width": "90px", "textAlign": "center" },
            { "no": 9, "text": "PGMID", "width": "100px", "textAlign": "center" },
            { "no": 10, "text": "자체즉결", "width": "80px", "textAlign": "center" },
            { "no": 11, "text": "실제 수수료", "width": "80px", "textAlign": "center" },
            { "no": 3, "text": "적용일자", "width": "70px", "textAlign": "center" },
            { "no": 4, "text": "종료일자", "width": "70px", "textAlign": "center" },
        ] : [
            { "no": 1, "text": "PG사", "width": "100px", "textAlign": "center" },
            { "no": 2, "text": "결제수단", "width": "70px", "textAlign": "center" },
            { "no": 5, "text": "수수료", "width": "60px", "textAlign": "center" },
            { "no": 6, "text": "키인형태", "width": "70px", "textAlign": "center" },
            { "no": 9, "text": "PGMID", "width": "100px", "textAlign": "center" },
            { "no": 10, "text": "자체즉결", "width": "80px", "textAlign": "center" },
            { "no": 11, "text": "실제 수수료", "width": "80px", "textAlign": "center" },
            { "no": 3, "text": "적용일자", "width": "70px", "textAlign": "center" },
            { "no": 4, "text": "종료일자", "width": "70px", "textAlign": "center" },
        ]

    // 예약 건 테이블 헤더 (적용 예정일 컬럼 추가)
    const reservationTableHeaderData = MyData.role == "SUPER" ?
        [
            { "no": 1, "text": "PG사", "width": "100px", "textAlign": "center" },
            { "no": 2, "text": "결제수단", "width": "70px", "textAlign": "center" },
            { "no": 5, "text": "수수료", "width": "60px", "textAlign": "center" },
            { "no": 6, "text": "키인형태", "width": "70px", "textAlign": "center" },
            { "no": 7, "text": "상위수수료", "width": "80px", "textAlign": "center" },
            { "no": 8, "text": "상위정산주기", "width": "90px", "textAlign": "center" },
            { "no": 9, "text": "PGMID", "width": "100px", "textAlign": "center" },
            { "no": 10, "text": "자체즉결", "width": "80px", "textAlign": "center" },
            { "no": 11, "text": "실제 수수료", "width": "80px", "textAlign": "center" },
            { "no": 3, "text": "적용일자", "width": "70px", "textAlign": "center" },
            { "no": 12, "text": "적용 예정일", "width": "90px", "textAlign": "center" },
        ] : [
            { "no": 1, "text": "PG사", "width": "100px", "textAlign": "center" },
            { "no": 2, "text": "결제수단", "width": "70px", "textAlign": "center" },
            { "no": 5, "text": "수수료", "width": "60px", "textAlign": "center" },
            { "no": 6, "text": "키인형태", "width": "70px", "textAlign": "center" },
            { "no": 9, "text": "PGMID", "width": "100px", "textAlign": "center" },
            { "no": 10, "text": "자체즉결", "width": "80px", "textAlign": "center" },
            { "no": 11, "text": "실제 수수료", "width": "80px", "textAlign": "center" },
            { "no": 3, "text": "적용일자", "width": "70px", "textAlign": "center" },
            { "no": 12, "text": "적용 예정일", "width": "90px", "textAlign": "center" },
        ]

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData?.slice((page - 1) * maxFirstPage, page * maxFirstPage) ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                let row = MyData.role == "SUPER" ?
                    [
                        {
                            "no": 1,
                            "text": data.pg_cd === "04" ? "원글로벌페이" : data.pg_cd === "22" ? "위즈페이" : data.pg_cd === "23" ? "위루트" : data.pg_cd,
                            "width": "100px",
                            "textAlign": "center"
                        },
                        { "no": 2, "text": data.svc_prdt_cd === "10" ? "단말기" : data.svc_prdt_cd === "11" ? "URL인증" : data.svc_prdt_cd === "08" ? "SMS인증" : data.svc_prdt_cd === "03" ? "SMS수기" : "수기", "width": "70px", "textAlign": "center" },
                        { "no": 5, "text": Number(data.fee) > 0 ? Number(data.fee).toLocaleString() : "", "width": "60px", "textAlign": "center" },
                        { "no": 6, "text": data.pg_key_in_ci === "01" ? "카유" : data.pg_key_in_ci === "02" ? "카유생" : data.pg_key_in_ci === "03" ? "카유생비" : data.pg_key_in_ci === "00" ? "단말기" : data.pg_key_in_ci, "width": "70px", "textAlign": "center" },
                        { "no": 7, "text": Number(data.org_fee) > 0 ? Number(data.org_fee).toLocaleString() : "", "width": "80px", "textAlign": "center" },
                        { "no": 8, "text": data.org_settlement_cycle, "width": "90px", "textAlign": "center" },
                        {
                            "no": 9, "text": (
                                <InfoIcon
                                    tooltipId="tooltip-icon"
                                    content={data.cat_id ?? data.pg_mid}
                                />
                            ), "width": "100px", "textAlign": "center", "visible": true
                        },
                        { "no": 10, "text": data.self_realtime === "Y" ? "사용" : data.self_realtime === "N" ? "미사용" : "", "width": "80px", "textAlign": "center" },
                        { "no": 11, "text": data.self_realtime_fee ? Number(data.self_realtime_fee).toLocaleString() : "-", "width": "80px", "textAlign": "center" },
                        { "no": 3, "text": `${data.fr_dt.slice(2, 4)}-${data.fr_dt.slice(4, 6)}-${data.fr_dt.slice(6, 8)}`, "width": "70px", "textAlign": "center" },
                        { "no": 4, "text": `${data.to_dt.slice(2, 4)}-${data.to_dt.slice(4, 6)}-${data.to_dt.slice(6, 8)}`, "width": "70px", "textAlign": "center" },
                    ] : [
                        {
                            "no": 1,
                            "text": data.pg_cd === "04" ? "원글로벌페이" : data.pg_cd === "22" ? "위즈페이" : data.pg_cd === "23" ? "위루트" : data.pg_cd,
                            "width": "100px",
                            "textAlign": "center"
                        },
                        { "no": 2, "text": data.svc_prdt_cd === "10" ? "단말기" : data.svc_prdt_cd === "11" ? "URL인증" : data.svc_prdt_cd === "08" ? "SMS인증" : data.svc_prdt_cd === "03" ? "SMS수기" : "수기", "width": "70px", "textAlign": "center" },
                        { "no": 5, "text": Number(data.fee) > 0 ? Number(data.fee).toLocaleString() : "", "width": "60px", "textAlign": "center" },
                        { "no": 6, "text": data.pg_key_in_ci === "01" ? "카유" : data.pg_key_in_ci === "02" ? "카유생" : data.pg_key_in_ci === "03" ? "카유생비" : data.pg_key_in_ci === "00" ? "단말기" : data.pg_key_in_ci, "width": "70px", "textAlign": "center" },
                        {
                            "no": 9, "text": (
                                <InfoIcon
                                    tooltipId="tooltip-icon"
                                    content={data.cat_id ?? data.pg_mid}
                                />
                            ), "width": "100px", "textAlign": "center", "visible": true
                        },
                        { "no": 10, "text": data.self_realtime === "Y" ? "사용" : data.self_realtime === "N" ? "미사용" : "", "width": "80px", "textAlign": "center" },
                        { "no": 11, "text": data.self_realtime_fee ? Number(data.self_realtime_fee).toLocaleString() : "-", "width": "80px", "textAlign": "center" },
                        { "no": 3, "text": `${data.fr_dt.slice(2, 4)}-${data.fr_dt.slice(4, 6)}-${data.fr_dt.slice(6, 8)}`, "width": "70px", "textAlign": "center" },
                        { "no": 4, "text": `${data.to_dt.slice(2, 4)}-${data.to_dt.slice(4, 6)}-${data.to_dt.slice(6, 8)}`, "width": "70px", "textAlign": "center" },
                    ]
                tableBodyData.push(row)
            }
            setCombineData(tableBodyData)
        }
    }, [listData, page, maxFirstPage])

    // 예약 건 데이터를 테이블 형태로 변환
    useEffect(() => {
        let reservationTableData = [];
        if (reservations && reservations.length > 0) {
            for (let i = 0; i < reservations.length; i++) {
                let reservation = reservations[i];
                let row = MyData.role == "SUPER" ?
                    [
                        {
                            "no": 1,
                            "text": reservation.pg_cd === "04" ? "원글로벌페이" : reservation.pg_cd === "22" ? "위즈페이" : reservation.pg_cd === "23" ? "위루트" : reservation.pg_cd,
                            "width": "100px",
                            "textAlign": "center"
                        },
                        { "no": 2, "text": reservation.svc_prdt_cd === "10" ? "단말기" : reservation.svc_prdt_cd === "11" ? "URL인증" : reservation.svc_prdt_cd === "08" ? "SMS인증" : reservation.svc_prdt_cd === "03" ? "SMS수기" : "수기", "width": "70px", "textAlign": "center" },
                        { "no": 5, "text": Number(reservation.fee) > 0 ? Number(reservation.fee).toLocaleString() : "", "width": "60px", "textAlign": "center" },
                        { "no": 6, "text": reservation.pg_key_in_ci === "01" ? "카유" : reservation.pg_key_in_ci === "02" ? "카유생" : reservation.pg_key_in_ci === "03" ? "카유생비" : reservation.pg_key_in_ci === "00" ? "단말기" : reservation.pg_key_in_ci, "width": "70px", "textAlign": "center" },
                        { "no": 7, "text": Number(reservation.org_fee) > 0 ? Number(reservation.org_fee).toLocaleString() : "", "width": "80px", "textAlign": "center" },
                        { "no": 8, "text": reservation.org_settlement_cycle, "width": "90px", "textAlign": "center" },
                        {
                            "no": 9, "text": (
                                <InfoIcon
                                    tooltipId={`tooltip-reservation-${i}`}
                                    content={reservation.cat_id ?? reservation.pg_mid ?? "-"}
                                />
                            ), "width": "100px", "textAlign": "center", "visible": true
                        },
                        { "no": 10, "text": reservation.self_realtime === "Y" ? "사용" : reservation.self_realtime === "N" ? "미사용" : (reservation.self_realtime ?? "-"), "width": "80px", "textAlign": "center" },
                        { "no": 11, "text": reservation.self_realtime_fee ? Number(reservation.self_realtime_fee).toLocaleString() : "-", "width": "80px", "textAlign": "center" },
                        { "no": 3, "text": reservation.fr_dt ? `${reservation.fr_dt.slice(2, 4)}-${reservation.fr_dt.slice(4, 6)}-${reservation.fr_dt.slice(6, 8)}` : "-", "width": "70px", "textAlign": "center" },
                        { "no": 12, "text": reservation.apply_dt ? reservation.apply_dt.split(" ")[0] : "-", "width": "90px", "textAlign": "center", "style": { color: "#dc2626", fontWeight: "bold" } },
                    ] : [
                        {
                            "no": 1,
                            "text": reservation.pg_cd === "04" ? "원글로벌페이" : reservation.pg_cd === "22" ? "위즈페이" : reservation.pg_cd === "23" ? "위루트" : reservation.pg_cd,
                            "width": "100px",
                            "textAlign": "center"
                        },
                        { "no": 2, "text": reservation.svc_prdt_cd === "10" ? "단말기" : reservation.svc_prdt_cd === "11" ? "URL인증" : reservation.svc_prdt_cd === "08" ? "SMS인증" : reservation.svc_prdt_cd === "03" ? "SMS수기" : "수기", "width": "70px", "textAlign": "center" },
                        { "no": 5, "text": Number(reservation.fee) > 0 ? Number(reservation.fee).toLocaleString() : "", "width": "60px", "textAlign": "center" },
                        { "no": 6, "text": reservation.pg_key_in_ci === "01" ? "카유" : reservation.pg_key_in_ci === "02" ? "카유생" : reservation.pg_key_in_ci === "03" ? "카유생비" : reservation.pg_key_in_ci === "00" ? "단말기" : reservation.pg_key_in_ci, "width": "70px", "textAlign": "center" },
                        {
                            "no": 9, "text": (
                                <InfoIcon
                                    tooltipId={`tooltip-reservation-${i}`}
                                    content={reservation.cat_id ?? reservation.pg_mid ?? "-"}
                                />
                            ), "width": "100px", "textAlign": "center", "visible": true
                        },
                        { "no": 10, "text": reservation.self_realtime === "Y" ? "사용" : reservation.self_realtime === "N" ? "미사용" : (reservation.self_realtime ?? "-"), "width": "80px", "textAlign": "center" },
                        { "no": 11, "text": reservation.self_realtime_fee ? Number(reservation.self_realtime_fee).toLocaleString() : "-", "width": "80px", "textAlign": "center" },
                        { "no": 3, "text": reservation.fr_dt ? `${reservation.fr_dt.slice(2, 4)}-${reservation.fr_dt.slice(4, 6)}-${reservation.fr_dt.slice(6, 8)}` : "-", "width": "70px", "textAlign": "center" },
                        { "no": 12, "text": reservation.apply_dt ? reservation.apply_dt.split(" ")[0] : "-", "width": "90px", "textAlign": "center", "style": { color: "#dc2626", fontWeight: "bold" } },
                    ]
                reservationTableData.push(row)
            }
            setReservationData(reservationTableData)
        } else {
            setReservationData([])
        }
    }, [reservations, MyData.role])

    // ▼ "취소" 버튼: formData를 originalFormData로 되돌린다
    const handleCancel = () => {
        setFormData(originalFormData);
        // 필요하다면 여기서 모달 닫기 로직도 추가 가능 (ex: setModal(false))
    };

    return (
        <div style={{ padding: "5px" }}>
            {/* <div id="submerchants-modal" class="modal show_modal" tabindex="-1"> */}
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    {
                        MyData.role == "SUPER" && (
                            <div style={{ padding: '0 0 0.5rem', overflowY: "auto", fontSize: "12px", display: 'flex', gap: "20px" }}>
                                <div className="list-info-box" style={{ width: "100%" }}>
                                    <div className="box-gap">
                                        <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                            <ul>
                                                <li className='mobile'>
                                                    <div className="inner" style={{ width: '100%' }}>
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>PG사</span>
                                                        <select
                                                            id="PG사"
                                                            name="PG사"
                                                            className="form-select"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                            value={formData.PG사}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">선택</option>
                                                            {/* <option value="03">코페이</option> */}
                                                            <option value="04">윈글로벌</option>
                                                            <option value="22">위즈페이</option>
                                                            <option value="23">위루트</option>
                                                        </select>
                                                    </div>
                                                </li>
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>결제수단</span>
                                                        <select
                                                            id="결제수단"
                                                            name="결제수단"
                                                            className="form-select"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                            value={formData.결제수단}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">선택</option>
                                                            <option value="01">카드수기</option>
                                                            <option value="03">SMS수기</option>
                                                            {formData.PG사 === "04" && <option value="08">SMS인증</option>}
                                                            <option value="10">단말기(IC)</option>
                                                            {formData.PG사 === "04" && <option value="11">URL인증결제</option>}
                                                        </select>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>적용일자</span>
                                                        <input
                                                            name='적용일자'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                            value={formData.적용일자}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px", display: "flex", alignItems: "center", gap: "4px" }}>
                                                            즉시 적용
                                                            <span
                                                                data-tooltip-id="tooltip-force-realtime-pg"
                                                                data-tooltip-content="체크 시 모든 변경 사항이 자정 예약 없이 즉시 반영됩니다."
                                                                style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                                                            >
                                                                <Info size={13} style={{ color: "#888" }} />
                                                            </span>
                                                        </span>
                                                        <label style={{ display: "flex", alignItems: "center", gap: "8px", padding: "0 8px", height: "34px", fontSize: "12px", cursor: "pointer" }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={formData.즉시적용}
                                                                onChange={(e) => setFormData(prev => ({ ...prev, 즉시적용: e.target.checked }))}
                                                                style={{ width: "14px", height: "14px", cursor: "pointer" }}
                                                            />
                                                            자정 예약 없이 즉시 반영
                                                        </label>
                                                        <Tooltip id="tooltip-force-realtime-pg" place="top" effect="solid" style={{ maxWidth: "240px", fontSize: "11px" }} />
                                                    </div>
                                                </li>
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>PGMID</span>
                                                        <input
                                                            name='PGMID'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                            value={formData.PGMID}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>PGKEY</span>
                                                        <input
                                                            name='PGKEY'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                            value={formData.PGKEY}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </li>
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>수수료</span>
                                                        <input
                                                            name='수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                            value={formData.수수료}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>키인형태</span>
                                                        <select
                                                            id="키인형태"
                                                            name="키인형태"
                                                            className="form-select"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                            value={formData.키인형태}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">선택</option>
                                                            <option value="01">카유</option>
                                                            <option value="02">카유생</option>
                                                            <option value="03">카유생비</option>
                                                            <option value="00">단말기</option>
                                                        </select>
                                                    </div>
                                                </li>
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>상위수수료</span>
                                                        <input
                                                            name='상위수수료'
                                                            type="text"
                                                            className="right-text"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                            value={formData.상위수수료}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>상위정산주기</span>
                                                        <select
                                                            id="상위정산주기"
                                                            name="상위정산주기"
                                                            className="form-select"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                            value={formData.상위정산주기}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="D0">당일</option>
                                                            <option value="D1">D+1</option>
                                                            {/* <option value="D2">D+2</option>
                                                            <option value="D3">D+3</option>
                                                            <option value="D4">D+4</option>
                                                            <option value="D5">D+5</option>
                                                            <option value="D6">D+6</option>
                                                            <option value="D7">D+7</option>
                                                            <option value="D8">D+8</option>
                                                            <option value="D9">D+9</option>
                                                            <option value="D10">D+10</option> */}
                                                        </select>
                                                    </div>
                                                </li>
                                                <li className='mobile'>
                                                    <div className="inner">
                                                        <span className="left-text" style={{ width: "120px", height: "34px" }}>자체즉결</span>
                                                        <select
                                                            id="자체즉결"
                                                            name="자체즉결"
                                                            className="form-select"
                                                            style={{ width: "calc(100% - 122px)", border: "none", outline: "none", fontSize: "0.7rem", color: "#646464" }}
                                                            value={formData.자체즉결}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="N">미사용</option>
                                                            <option value="Y">사용</option>
                                                        </select>
                                                    </div>
                                                    {/* 자체즉결이 Y일 때만 실제 수수료 필드 표시 */}
                                                    {formData.자체즉결 === "Y" && (
                                                        <div className="inner">
                                                            <span className="left-text" style={{ width: "120px", height: "34px", backgroundColor: "#fff3cd", display: "flex", alignItems: "center", gap: "4px" }}>
                                                                실제 수수료
                                                                <span
                                                                    data-tooltip-id="tooltip-realtime-fee"
                                                                    data-tooltip-content="'수수료' - '실제 수수료' = '추가 수익'"
                                                                    style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                                                                >
                                                                    <Info size={14} style={{ color: "#856404" }} />
                                                                </span>
                                                            </span>
                                                            <input
                                                                name='실제수수료'
                                                                type="text"
                                                                className="right-text"
                                                                style={{ width: "calc(100% - 122px)", border: "none", outline: "none" }}
                                                                value={formData.실제수수료}
                                                                onChange={handleChange}
                                                            />
                                                            <Tooltip
                                                                id="tooltip-realtime-fee"
                                                                place="top"
                                                                effect="solid"
                                                                clickable={true}
                                                                delayHide={500}
                                                                style={{
                                                                    backgroundColor: "#000",
                                                                    color: "#fff",
                                                                    border: "1px solid gray",
                                                                    padding: "8px 10px",
                                                                    borderRadius: "5px",
                                                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                                                                    opacity: 1,
                                                                    userSelect: "text",
                                                                    pointerEvents: "auto",
                                                                    zIndex: "100000"
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    {/* 예약된 PG 정보 변경 건 표시 */}
                    {reservations && reservations.length > 0 && (
                        <div style={{ marginBottom: "15px" }}>
                            <div style={{
                                fontWeight: "bold",
                                color: "#856404",
                                marginBottom: "8px",
                                fontSize: "13px",
                                padding: "5px 0"
                            }}>
                                ⚠️ 예약된 PG 정보 변경 건
                            </div>
                            <List
                                tableHeaderData={reservationTableHeaderData}
                                tableBodyData={reservations ?? []}
                                filter_tableBodyData={reservationData}
                                page={1}
                                setPage={() => { }}
                                maxFirstPage={reservations.length}
                                nonePage={true}
                            />
                        </div>
                    )}

                    <div>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData ?? []}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            // height={"205px"}
                            nonePage={false}
                        />
                    </div>

                    {/* 중복 클릭 방지 */}
                    {
                        MyData.role == "SUPER" && (
                            <div className="modal-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary w-20 reg_btn"
                                    onClick={() => onSubmit()}
                                    disabled={isSubmitting} // 비활성화 조건
                                >
                                    등록
                                </button>
                                {/* ▼ 닫기 -> 취소, 기존값으로 복원 */}
                                <input
                                    type="button"
                                    className="btn btn-primary w-20 close_btn"
                                    onClick={() => handleCancel()}
                                    style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }}
                                    value="취소"
                                />
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

function URLPayment({ setMessage, clickData, setReload }) {
    const [listData, setListData] = useState([]);
    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(5);
    const [combineData, setCombineData] = useState([]);
    const [clickUrlData, setClickUrlData] = useState(null); // 선택된 항목(없으면 null)

    // 숫자 포맷/파싱
    const stripDigits = (v) => (v ?? "").toString().replace(/\D/g, "");
    const formatNumber = (v) => {
        const raw = stripDigits(v);
        if (!raw) return "";
        return raw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const changeNum = (n) => {
        if (Number.isNaN(n)) return "0";
        return n.toLocaleString();
    };

    // 초기값 생성
    const buildInitialFormData = (cd) => {
        const statusFromType =
            cd?.product_type !== undefined
                ? String(cd.product_type) === "1"
                    ? "Y"
                    : "N"
                : undefined;

        return {
            productName: cd?.product_name ?? "",
            productCode: cd?.product_code ?? "",
            amount: stripDigits(cd?.price),    // raw 숫자문자열
            stock: stripDigits(cd?.quantity),  // raw 숫자문자열
            url: cd?.product_url ?? "",
            status: statusFromType ?? "Y",
        };
    };

    // 원본/폼 상태
    const [originalFormData, setOriginalFormData] = useState(buildInitialFormData(null));
    const [formData, setFormData] = useState(buildInitialFormData(null));

    // merchant 변경 시 초기화
    useEffect(() => {
        URLList();
        setClickUrlData(null);
        const init = buildInitialFormData(null);
        setOriginalFormData(init);
        setFormData(init);
    }, [clickData]);

    // 선택 항목 변경 시 폼 동기화
    useEffect(() => {
        const init = buildInitialFormData(clickUrlData);
        setOriginalFormData(init);
        setFormData(init);
    }, [clickUrlData]);

    // 리스트 조회
    const URLList = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + `/api/merchant/url-pay/products`,
                {
                    withCredentials: true,
                    params: { mid: clickData?.mid },
                }
            );
            const tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp.data?.products || []);
            }
        } catch (error) {
            console.error(error);
        }
    };

    // 테이블 데이터 구성
    useEffect(() => {
        const tableBodyData = [];
        for (let i = 0; i < listData.length; i++) {
            const data = listData[i];
            let rowData = [
                { no: 1, text: data.product_code, width: "100px", textAlign: "center" },
                { no: 2, text: data.product_name, width: "70px", textAlign: "center" },
                { no: 5, text: changeNum(Number(data.price)), width: "60px", textAlign: "center" },
                { no: 6, text: changeNum(Number(data.quantity)), width: "70px", textAlign: "center" },
                {
                    no: 7,
                    text: String(data.product_type) === "1" ? "활성" : "비활성",
                    width: "80px",
                    textAlign: "center",
                },
            ];
            rowData.id = data.id; // 식별자
            tableBodyData.push(rowData);
        }
        setCombineData(tableBodyData);
    }, [listData]);

    // onChange 공통
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // 숫자만 허용 + raw 저장 + 표시 포맷은 렌더링 때 적용
    const handleNumericChange = (e) => {
        const { name, value } = e.target; // value는 쉼표 포함 가능
        const raw = stripDigits(value).slice(0, 12);
        setFormData((prev) => ({ ...prev, [name]: raw }));
    };

    // 행 클릭
    const handleRowClick = (row) => {
        const found = listData.find((d) => d.id == row.id);
        if (found) setClickUrlData(found);
    };

    const isEdit = !!clickUrlData?.id;

    // 제출
    const [isSubmitting, setIsSubmitting] = useState(false);
    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            if (!formData.productName || !formData.amount || !formData.stock || !formData.status) {
                setMessage({ msg: "필수 항목(상품명/금액/재고/상태)을 모두 입력해주세요." });
                return;
            }

            let endpoint = process.env.REACT_APP_API + "/api/merchant/url-pay/products";
            let body = {
                mid: clickData?.mid,
                productName: formData.productName,
                price: formData.amount, // raw 숫자문자열
                quantity: formData.stock,   // raw 숫자문자열
                productType: formData.status == "Y" ? "1" : "2", // "Y" | "N"
            };

            if (isEdit) {
                if (!formData.productCode) {
                    setMessage({ msg: "상품코드를 확인해주세요." });
                    return;
                }
                body = {
                    ...body,
                    product_code: formData.productCode,
                    url: formData.url,
                };
            }

            const res = await axios.post(endpoint, body, { withCredentials: true });

            const tmp = res?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setMessage({ msg: isEdit ? "수정에 성공했습니다." : "등록에 성공했습니다." });

                URLList();
                if (!isEdit) {
                    // 등록 성공 시 초기화
                    setClickUrlData(null);
                    const init = buildInitialFormData(null);
                    setOriginalFormData(init);
                    setFormData(init);
                }
            } else {
                setMessage({ msg: (isEdit ? "수정" : "등록") + "에 실패했습니다." });
            }
        } catch (e) {
            console.error(e);
            setMessage({ msg: "요청 처리 중 오류가 발생했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // 취소
    const handleCancel = () => {
        if (isEdit) {
            setClickUrlData(null);
            const init = buildInitialFormData(null);
            setOriginalFormData(init);
            setFormData(init);
        } else {
            setFormData(originalFormData);
        }
    };

    const tableHeaderData = [
        { no: 1, text: "상품코드", width: "100px", textAlign: "center" },
        { no: 2, text: "상품명", width: "70px", textAlign: "center" },
        { no: 5, text: "결제금액", width: "60px", textAlign: "center" },
        { no: 6, text: "재고", width: "70px", textAlign: "center" },
        { no: 7, text: "상태", width: "80px", textAlign: "center" },
    ];

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    {/* 입력 폼 */}
                    <div
                        style={{
                            padding: "0 0 0.5rem",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: "flex",
                            gap: "20px",
                        }}
                    >
                        <div className="list-info-box" style={{ width: "100%" }}>
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        <li className="mobile">
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    URL
                                                </span>
                                                <input
                                                    name="url"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        background: "#f4f4f4",
                                                        cursor: "not-allowed",
                                                    }}
                                                    value={formData.url}
                                                    readOnly
                                                    tabIndex={-1}
                                                />
                                            </div>

                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    상품코드
                                                </span>
                                                <input
                                                    name="productCode"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        background: "#f4f4f4",
                                                        cursor: "not-allowed",
                                                    }}
                                                    value={formData.productCode}
                                                    readOnly
                                                    tabIndex={-1}
                                                />
                                            </div>
                                        </li>

                                        <li className="mobile">
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    상품명
                                                </span>
                                                <input
                                                    name="productName"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.productName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    상태
                                                </span>
                                                <select
                                                    id="status"
                                                    name="status"
                                                    className="form-select"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        fontSize: "0.7rem",
                                                        color: "#646464",
                                                    }}
                                                    value={formData.status}
                                                    onChange={handleChange}
                                                >
                                                    <option value="Y">활성</option>
                                                    <option value="N">비활성</option>
                                                </select>
                                            </div>
                                        </li>

                                        {/* 결제금액 / 재고 (자동 , 포맷) */}
                                        <li className="mobile">
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    결제금액
                                                </span>
                                                <input
                                                    name="amount"
                                                    type="text"
                                                    className="right-text"
                                                    inputMode="numeric"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formatNumber(formData.amount)}
                                                    onChange={handleNumericChange}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    재고
                                                </span>
                                                <input
                                                    name="stock"
                                                    type="text"
                                                    className="right-text"
                                                    inputMode="numeric"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formatNumber(formData.stock)}
                                                    onChange={handleNumericChange}
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 리스트 */}
                    <div>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData ?? []}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            clickData={clickUrlData}
                            onRowClick={handleRowClick}
                            nonePage={false}
                            height={"300px"}
                        />
                    </div>

                    {/* 푸터 */}
                    {
                        isEdit
                            ?
                            <div className="modal-footer">
                                <input
                                    type="button"
                                    className="btn btn-primary w-20 close_btn"
                                    onClick={() => setClickUrlData(null)}
                                    style={{
                                        backgroundColor: "darkred",
                                        marginLeft: "10px",
                                        border: "none",
                                    }}
                                    value="취소"
                                />
                            </div>
                            :
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary w-20 reg_btn"
                                    onClick={onSubmit}
                                    disabled={isSubmitting}
                                >
                                    {isEdit ? "수정" : "등록"}
                                </button>
                                <input
                                    type="button"
                                    className="btn btn-primary w-20 close_btn"
                                    onClick={handleCancel}
                                    style={{
                                        backgroundColor: "darkred",
                                        marginLeft: "10px",
                                        border: "none",
                                    }}
                                    value="취소"
                                />
                            </div>
                    }
                </div>
            </div>
        </div>
    );
}

function Wallet({ setMessage, clickData, setReload }) {
    const [listData, setListData] = useState([]);
    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(5);
    const [combineData, setCombineData] = useState([]);
    const [clickUrlData, setClickUrlData] = useState(null); // 선택된 항목(없으면 null)

    // 숫자 포맷/파싱
    const stripDigits = (v) => (v ?? "").toString().replace(/\D/g, "");
    const formatNumber = (v) => {
        const raw = stripDigits(v);
        if (!raw) return "";
        return raw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const changeNum = (n) => {
        if (Number.isNaN(n)) return "0";
        return n.toLocaleString();
    };

    // 초기값 생성
    const buildInitialFormData = (cd) => {
        return {
            totalAmount: stripDigits(cd?.price),
            avaliableAmount: stripDigits(cd?.price),
            lockAmount: stripDigits(cd?.price),
        };
    };

    const [formData, setFormData] = useState(buildInitialFormData(null));

    useEffect(() => {
        URLList();
        walletInfo();
    }, [])

    // 리스트 조회
    const URLList = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + `/api/merchant/wallet/transactions`,
                {
                    withCredentials: true,
                    params: { mid: clickData?.mid, page: page, limit: maxFirstPage },
                }
            );
            const tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp.data?.transactions || []);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const walletInfo = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + `/api/merchant/wallet/accounts`,
                {
                    withCredentials: true,
                    params: { mid: clickData?.mid },
                }
            );
            const tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setFormData({
                    totalAmount: Number(tmp.data?.wallet.total_balance || 0).toLocaleString(),
                    avaliableAmount: Number(tmp.data?.wallet.available_balance || 0).toLocaleString(),
                    lockAmount: Number((tmp.data?.wallet.frozen_balance || 0) + (tmp.data?.wallet.locked_balance || 0)).toLocaleString(),
                });
            }
            console.log(formData);
        } catch (error) {
            console.error(error);
        }
    }

    // 테이블 데이터 구성
    useEffect(() => {
        const tableBodyData = [];
        for (let i = 0; i < listData.length; i++) {
            const data = listData[i];

            // 거래 타입에 따른 색상 설정
            const getTransactionTypeInfo = (txType) => {
                switch (txType) {
                    case 'WITHDRAW':
                        return { color: '#dc2626', text: '출금', bgColor: '#fef2f2' };
                    case 'DEPOSIT':
                        return { color: '#059669', text: '입금', bgColor: '#f0fdf4' };
                    case 'TRANSFER':
                        return { color: '#2563eb', text: '이체', bgColor: '#eff6ff' };
                    default:
                        return { color: '#6b7280', text: '기타', bgColor: '#f9fafb' };
                }
            };

            // 상태별 색상 설정
            const getStatusColor = (status) => {
                switch (status) {
                    case 'SUCCESS':
                        return '#059669';
                    case 'PENDING':
                        return '#d97706';
                    case 'FAILED':
                        return '#dc2626';
                    case 'CANCELLED':
                        return '#6b7280';
                    default:
                        return '#6b7280';
                }
            };

            const txTypeInfo = getTransactionTypeInfo(data.tx_type);
            const statusColor = getStatusColor(data.status);

            let rowData = [
                {
                    no: 1,
                    text: txTypeInfo.text,
                    width: "80px",
                    textAlign: "center",
                    style: {
                        color: txTypeInfo.color,
                        fontWeight: 'bold',
                        backgroundColor: txTypeInfo.bgColor,
                        fontSize: '12px'
                    }
                },
                {
                    no: 2,
                    text: `${data.bank_nm || '-'} ${data.accnt_no ? `(${data.accnt_no.slice(-4)})` : ''}`,
                    width: "150px",
                    textAlign: "center",
                    style: {
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#374151'
                    }
                },
                {
                    no: 3,
                    text: changeNum(Number(data.amount || 0)),
                    width: "100px",
                    textAlign: "right",
                    style: {
                        fontWeight: 'bold',
                        fontSize: '13px',
                        color: data.tx_type === 'WITHDRAW' ? '#dc2626' : '#059669'
                    }
                },
                {
                    no: 4,
                    text: changeNum(Number(data.balance_before || 0)),
                    width: "100px",
                    textAlign: "right",
                    style: {
                        fontSize: '11px',
                        color: '#6b7280',
                        fontFamily: 'monospace'
                    }
                },
                {
                    no: 5,
                    text: changeNum(Number(data.balance_after || 0)),
                    width: "100px",
                    textAlign: "right",
                    style: {
                        fontWeight: 'bold',
                        fontSize: '13px',
                        color: '#1f2937'
                    }
                },
                {
                    no: 6,
                    text: data.status === 'SUCCESS' ? '완료' :
                        data.status === 'PENDING' ? '대기' :
                            data.status === 'FAILED' ? '실패' :
                                data.status === 'CANCELLED' ? '취소' : data.status,
                    width: "60px",
                    textAlign: "center",
                    style: {
                        color: statusColor,
                        fontWeight: 'bold',
                        backgroundColor: statusColor + '20',
                        fontSize: '11px'
                    }
                },
                {
                    no: 7,
                    text: data.completed_at ?
                        new Date(data.completed_at).toLocaleDateString('ko-KR', {
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                        }) :
                        new Date(data.created_at).toLocaleDateString('ko-KR', {
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                        }),
                    width: "100px",
                    textAlign: "center",
                    style: {
                        fontSize: '11px',
                        color: '#6b7280',
                        fontFamily: 'monospace'
                    }
                },
            ];
            rowData.id = data.id; // 식별자
            tableBodyData.push(rowData);
        }
        setCombineData(tableBodyData);
    }, [listData]);

    const tableHeaderData = [
        { no: 1, text: "거래유형", width: "80px", textAlign: "center" },
        { no: 2, text: "계좌정보", width: "150px", textAlign: "center" },
        { no: 3, text: "거래금액", width: "100px", textAlign: "center" },
        { no: 4, text: "거래전잔액", width: "100px", textAlign: "center" },
        { no: 5, text: "거래후잔액", width: "100px", textAlign: "center" },
        { no: 6, text: "상태", width: "60px", textAlign: "center" },
        { no: 7, text: "거래일시", width: "100px", textAlign: "center" },
    ];

    return (
        <div style={{ padding: "5px" }}>
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty">
                    {/* 입력 폼 */}
                    <div
                        style={{
                            padding: "0 0 0.5rem",
                            overflowY: "auto",
                            fontSize: "12px",
                            display: "flex",
                            gap: "20px",
                        }}
                    >
                        <div className="list-info-box" style={{ width: "100%" }}>
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        <li className="mobile">
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    총액
                                                </span>
                                                <input
                                                    name="totalAmount"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        cursor: "not-allowed",
                                                    }}
                                                    value={formData.totalAmount}
                                                    readOnly
                                                    tabIndex={-1}
                                                />
                                            </div>
                                        </li>

                                        <li className="mobile">
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    출금가능
                                                </span>
                                                <input
                                                    name="avaliableAmount"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        cursor: "not-allowed",
                                                    }}
                                                    value={formData.avaliableAmount}
                                                    readOnly
                                                    tabIndex={-1}
                                                />
                                            </div>
                                            <div className="inner">
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    출금동결
                                                </span>
                                                <input
                                                    name="lockAmount"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                        cursor: "not-allowed",
                                                    }}
                                                    value={formData.lockAmount}
                                                    readOnly
                                                    tabIndex={-1}
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 리스트 */}
                    <div>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData ?? []}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            nonePage={false}
                            height={"300px"}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

function InfoIcon({ content, tooltipId }) {
    // 재사용 툴팁 아이콘
    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span
                data-tooltip-id={tooltipId}
                data-tooltip-content={content}
                style={{ cursor: "pointer", fontSize: "12px" }}
                className='table-overflow-hidden'
            >
                {content}
            </span>
            <Tooltip
                id={tooltipId}
                place="top"
                effect="solid"
                clickable={true} // ✅ 이걸 꼭 넣어야 마우스 진입 시 툴팁이 안 사라짐
                delayHide={500}  // ✅ 마우스가 벗어났을 때 바로 안 사라지도록 지연
                style={{
                    backgroundColor: "#000",
                    color: "#fff",
                    border: "1px solid gray",
                    padding: "8px 10px",
                    borderRadius: "5px",
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                    opacity: 1,
                    userSelect: "text",
                    pointerEvents: "auto",
                    zIndex: "100000"
                }}
            />
        </div>
    );
}

const Excel = (excelData, tier, excelPrefix, { formatLabel = "" } = {}) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const timestamp = dayjs().format("YYYYMMDD_HHmm");
    const brandPart = excelPrefix ? `_${excelPrefix}` : "";
    const formatPart = formatLabel ? `_${formatLabel}` : "";
    const excelFileName = `가맹점관리${brandPart}${formatPart}_${timestamp}`;

    const headerRow = tier === "sub"
        ?
        [
            "등록일", "사업자등록번호", "가맹점ID", "상호명", "대표자명", "연락처", "사업장주소",
            "지사", "지사수수료", "총판", "총판수수료", "대리점", "대리점수수료", "영업자1", "영업자1수수료", "영업자2", "영업자2수수료",
            "영업자3", "영업자3수수료", "가맹점수수료", "정산은행", "계좌번호", "예금주"
        ]
        :
        [
            "등록일", "사업자등록번호", "가맹점ID", "상호명", "대표자명", "연락처", "사업장주소",
            "지사", "지사수수료", "총판", "총판수수료", "대리점", "대리점수수료", "영업자1", "영업자1수수료", "영업자2", "영업자2수수료",
            "영업자3", "영업자3수수료", "가맹점수수료", "정산은행", "계좌번호", "예금주",
            "바우처사용", "수기노출", "정산주기", "적용일자", "즉시여부", "정산지연분", "PGMID"
        ]

    const bodyRows = tier === "sub"
        ?
        excelData.map((data) => ([
            data.등록일, data.사업자등록번호, data.가맹점ID, data.상호명, data.대표자명, data.연락처, data.사업장주소,
            data.지사, data.지사수수료, data.총판, data.총판수수료, data.대리점, data.대리점수수료, data.영업자1, data.영업자1수수료,
            data.영업자2, data.영업자2수수료, data.영업자3, data.영업자3수수료, data.가맹점수수료, data.정산은행, data.계좌번호, data.예금주
        ]))
        :
        excelData.map((data) => ([
            data.등록일, data.사업자등록번호, data.가맹점ID, data.상호명, data.대표자명, data.연락처, data.사업장주소,
            data.지사, data.지사수수료, data.총판, data.총판수수료, data.대리점, data.대리점수수료, data.영업자1, data.영업자1수수료,
            data.영업자2, data.영업자2수수료, data.영업자3, data.영업자3수수료, data.가맹점수수료, data.정산은행, data.계좌번호, data.예금주,
            data.바우처사용, data.수기노출, data.정산주기, data.적용일자, data.즉시여부, data.정산지연분, data.PGMID
        ]))

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default Submerchants
